import React, { useState, useMemo, useEffect } from 'react';
import { BrowserRouter, Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { initializeApp } from 'firebase/app';
import { getFirestore, collection, addDoc, getDocs, getDoc, doc, updateDoc, deleteDoc, query, where, orderBy, serverTimestamp } from 'firebase/firestore';
import { getAuth, signInWithPopup, GoogleAuthProvider, onAuthStateChanged, signOut, createUserWithEmailAndPassword, signInWithEmailAndPassword, sendPasswordResetEmail, deleteUser } from 'firebase/auth';

// Firebase Configuration
const firebaseConfig = {
  apiKey: "AIzaSyAlWOlACNYwpl8RTrKhZ4nx964pgBy_u-A",
  authDomain: "graycorp-soc.firebaseapp.com",
  projectId: "graycorp-soc",
  storageBucket: "graycorp-soc.firebasestorage.app",
  messagingSenderId: "315255817917",
  appId: "1:315255817917:web:fd0bb2bd1e98acd1a759d4"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();

// Icons
const Icons = {
  shield: (p) => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...p}><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>,
  shieldCheck: (p) => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...p}><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="m9 12 2 2 4-4"/></svg>,
  eye: (p) => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...p}><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>,
  database: (p) => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...p}><ellipse cx="12" cy="5" rx="9" ry="3"/><path d="M21 12c0 1.66-4 3-9 3s-9-1.34-9-3"/><path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5"/></svg>,
  search: (p) => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...p}><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>,
  alertTriangle: (p) => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...p}><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>,
  zap: (p) => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...p}><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>,
  clipboard: (p) => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...p}><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/><rect x="8" y="2" width="8" height="4" rx="1" ry="1"/></svg>,
  lock: (p) => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...p}><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>,
  unlock: (p) => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...p}><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 9.9-1"/></svg>,
  refreshCw: (p) => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...p}><polyline points="23 4 23 10 17 10"/><polyline points="1 20 1 14 7 14"/><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"/></svg>,
  target: (p) => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...p}><circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="6"/><circle cx="12" cy="12" r="2"/></svg>,
  users: (p) => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...p}><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>,
  arrowRight: (p) => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...p}><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>,
  arrowLeft: (p) => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...p}><line x1="19" y1="12" x2="5" y2="12"/><polyline points="12 19 5 12 12 5"/></svg>,
  check: (p) => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...p}><polyline points="20 6 9 17 4 12"/></svg>,
  checkCircle: (p) => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...p}><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>,
  download: (p) => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...p}><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>,
  barChart: (p) => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...p}><line x1="12" y1="20" x2="12" y2="10"/><line x1="18" y1="20" x2="18" y2="4"/><line x1="6" y1="20" x2="6" y2="16"/></svg>,
  logOut: (p) => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...p}><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>,
  trash: (p) => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...p}><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>,
  play: (p) => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...p}><polygon points="5 3 19 12 5 21 5 3"/></svg>,
  save: (p) => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...p}><path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"/><polyline points="17 21 17 13 7 13 7 21"/><polyline points="7 3 7 8 15 8"/></svg>,
  grid: (p) => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...p}><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/></svg>,
  externalLink: (p) => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...p}><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/><polyline points="15 3 21 3 21 9"/><line x1="10" y1="14" x2="21" y2="3"/></svg>,
  chevronDown: (p) => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...p}><polyline points="6 9 12 15 18 9"/></svg>,
  chevronUp: (p) => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...p}><polyline points="18 15 12 9 6 15"/></svg>,
  mail: (p) => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...p}><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>,
  x: (p) => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...p}><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>,
};

// Save assessment to Firestore
const saveAssessment = async (userId, clientInfo, answers, scores, overallScore, maturityLevel, status = 'completed', existingId = null) => {
  try {
    const data = {
      userId: userId || 'anonymous',
      clientInfo: {
        name: clientInfo.name || '',
        email: clientInfo.email || '',
        organization: clientInfo.organization || '',
        industry: clientInfo.industry || '',
        companySize: clientInfo.companySize || '',
        socSize: clientInfo.socSize || ''
      },
      answers: answers,
      scores: scores,
      overallScore: overallScore,
      maturityLevel: maturityLevel,
      status: status,
      updatedAt: serverTimestamp(),
      source: window.location.hostname
    };
    
    if (existingId) {
      // Update existing assessment
      await updateDoc(doc(db, 'assessments', existingId), data);
      console.log('Assessment updated:', existingId);
      return existingId;
    } else {
      // Create new assessment
      data.createdAt = serverTimestamp();
      const docRef = await addDoc(collection(db, 'assessments'), data);
      console.log('Assessment saved with ID:', docRef.id);
      return docRef.id;
    }
  } catch (error) {
    console.error('Error saving assessment:', error);
    return null;
  }
};

// Fetch user's past assessments
const fetchUserAssessments = async (userId) => {
  try {
    const q = query(
      collection(db, 'assessments'),
      where('userId', '==', userId),
      orderBy('updatedAt', 'desc')
    );
    const querySnapshot = await getDocs(q);
    const assessments = [];
    querySnapshot.forEach((doc) => {
      assessments.push({ id: doc.id, ...doc.data() });
    });
    return assessments;
  } catch (error) {
    console.error('Error fetching assessments:', error);
    return [];
  }
};

// ============================================================
// ENTERPRISE SOC ASSESSMENT - FULL QUESTION BANK
// ============================================================

const assessmentSections = [
  {
    id: 'detection_surface',
    name: 'Detection Surface',
    nistFunction: 'DETECT',
    icon: 'search',
    weight: 0.15,
    description: 'Coverage inventory, tool configuration, and visibility gaps',
    subsections: [
      {
        id: 'edr',
        name: 'Endpoint Detection & Response',
        questions: [
          { id: 'EDR-001', text: 'What percentage of endpoints (workstations, servers, VMs) have EDR agents installed and actively reporting?', options: ['< 50% coverage or unknown', '50-75% coverage', '75-90% coverage', '90-98% coverage', '> 98% with automated deployment and compliance monitoring'], weights: [1,2,3,4,5] },
          { id: 'EDR-002', text: 'Are EDR prevention policies enabled (not just detect/alert mode)?', options: ['Detection-only mode across environment', 'Prevention enabled for some threat categories', 'Prevention enabled for most categories with exceptions', 'Full prevention mode with documented exception process', 'Full prevention with continuous exception review and reduction program'], weights: [1,2,3,4,5] },
          { id: 'EDR-003', text: 'How are EDR sensor policies configured and maintained?', options: ['Vendor defaults, rarely modified', 'Some customization at deployment, then static', 'Policies reviewed annually', 'Policies reviewed quarterly with threat-driven updates', 'Continuous policy optimization based on telemetry, incidents, and threat intel'], weights: [1,2,3,4,5] },
          { id: 'EDR-004', text: 'Are on-demand scans (ODS) scheduled for high-risk systems?', options: ['No scheduled scans', 'Ad-hoc scans only', 'Monthly full scans on servers', 'Weekly scans on critical systems, monthly elsewhere', 'Risk-based scanning schedule with automated compliance verification'], weights: [1,2,3,4,5] },
          { id: 'EDR-005', text: 'How are EDR exclusions managed?', options: ['Exclusions added as needed, never reviewed', 'Exclusions documented but not reviewed', 'Annual exclusion review', 'Quarterly review with justification required', 'Automated exclusion auditing with expiration dates and revalidation'], weights: [1,2,3,4,5] },
          { id: 'EDR-006', text: 'Is EDR telemetry forwarded to your SIEM or data lake?', options: ['No integration', 'Alerts only forwarded', 'Alerts and limited telemetry', 'Full telemetry forwarded', 'Full telemetry with custom parsing and correlation rules built on EDR data'], weights: [1,2,3,4,5] },
          { id: 'EDR-007', text: 'Can you take response actions (isolate, kill process, etc.) from your SOAR or central console?', options: ['Must use native EDR console only', 'Some actions available via API but not integrated', 'Basic actions (isolate) integrated into SOAR', 'Most response actions automated in playbooks', 'Full response capability integrated with conditional logic and approval workflows'], weights: [1,2,3,4,5] },
        ]
      },
      {
        id: 'network',
        name: 'Network Security',
        questions: [
          { id: 'NET-001', text: 'Are firewall logs (permit and deny) collected centrally?', options: ['No firewall logging', 'Deny logs only, not centralized', 'Deny logs centralized', 'Permit and deny logs centralized', 'Full logging with session data, centralized, parsed, and retention > 90 days'], weights: [1,2,3,4,5] },
          { id: 'NET-002', text: 'Do you have network-based intrusion detection/prevention?', options: ['No IDS/IPS', 'IDS at perimeter only', 'IDS/IPS at perimeter and key segments', 'IDS/IPS with internal east-west visibility', 'Full coverage including cloud VPCs with tuned signatures and anomaly detection'], weights: [1,2,3,4,5] },
          { id: 'NET-003', text: 'Do you have NDR or network traffic analysis capabilities?', options: ['No NDR capability', 'Basic netflow collection', 'NDR tool deployed on key segments', 'NDR with ML-based anomaly detection', 'Full NDR with encrypted traffic analysis, integrated with SIEM/SOAR'], weights: [1,2,3,4,5] },
          { id: 'NET-004', text: 'Is DNS traffic logged and analyzed?', options: ['No DNS logging', 'DNS logs collected but not analyzed', 'DNS logs in SIEM with basic alerts', 'DNS security tool with blocking', 'Full DNS visibility with threat intel integration, DGA detection, and response automation'], weights: [1,2,3,4,5] },
          { id: 'NET-005', text: 'Are web traffic logs collected and analyzed?', options: ['No proxy or SWG', 'Proxy exists but logs not collected', 'Proxy logs in SIEM', 'SWG with categorization, SSL inspection, threat scanning', 'Full SWG with DLP, threat intel, CASB integration, and SIEM correlation'], weights: [1,2,3,4,5] },
          { id: 'NET-006', text: 'What email security controls are in place and monitored?', options: ['Basic spam filter only', 'Email gateway with malware scanning', 'Gateway + URL rewriting + attachment sandboxing', 'Above + DMARC/DKIM/SPF enforcement + logging to SIEM', 'Full stack with BEC detection, user reporting integration, and automated response'], weights: [1,2,3,4,5] },
          { id: 'NET-007', text: 'Can you detect lateral movement across network segments?', options: ['Flat network, no segmentation', 'Segmented but no visibility into inter-segment traffic', 'Firewall logs show inter-segment traffic', 'Internal IDS/NDR monitors lateral movement', 'Zero trust architecture with continuous verification and anomaly detection'], weights: [1,2,3,4,5] },
        ]
      },
      {
        id: 'identity',
        name: 'Identity & Access',
        questions: [
          { id: 'IAM-001', text: 'Are authentication events (success/fail) logged centrally?', options: ['No auth logging', 'Failed logins only, not centralized', 'All auth events centralized for some systems', 'All auth events centralized for all systems', 'Full auth logging with context (device, location, MFA method) and real-time alerting'], weights: [1,2,3,4,5] },
          { id: 'IAM-002', text: 'How are privileged account activities monitored?', options: ['No privileged access monitoring', 'Privileged logins logged', 'PAM solution deployed, logs collected', 'PAM with session recording, alerts on anomalies', 'Full PAM with JIT access, approval workflows, session monitoring, and SIEM integration'], weights: [1,2,3,4,5] },
          { id: 'IAM-003', text: 'Do you have visibility into service account usage?', options: ['No inventory of service accounts', 'Inventory exists but usage not monitored', 'Service account auth events logged', 'Service account behavior baselined and alerted', 'Full lifecycle management with automated rotation, usage monitoring, and anomaly detection'], weights: [1,2,3,4,5] },
          { id: 'IAM-004', text: 'Do you have identity-focused threat detection (ITDR)?', options: ['No ITDR capability', 'Basic impossible travel alerts', 'Identity analytics for anomaly detection', 'ITDR tool with ML-based risk scoring', 'Full ITDR integrated with SIEM/SOAR, correlation with endpoint and network signals'], weights: [1,2,3,4,5] },
          { id: 'IAM-005', text: 'What percentage of accounts have MFA enforced?', options: ['< 25% or only VPN', '25-50% coverage', '50-75% coverage', '75-95% coverage', '> 95% with phishing-resistant MFA (FIDO2) and continuous verification'], weights: [1,2,3,4,5] },
          { id: 'IAM-006', text: 'Are AD/Azure AD/Okta/etc. logs collected and analyzed?', options: ['Not collected', 'Collected but not analyzed', 'Basic alerts (account lockout, group changes)', 'Advanced detection (DCSync, Golden Ticket, permission changes)', 'Full coverage with attack path analysis and identity hygiene monitoring'], weights: [1,2,3,4,5] },
        ]
      },
      {
        id: 'cloud',
        name: 'Cloud Security',
        questions: [
          { id: 'CLD-001', text: 'Do you maintain visibility into cloud assets (IaaS/PaaS)?', options: ['No cloud inventory', 'Manual inventory, updated periodically', 'CSPM tool deployed for inventory', 'Continuous inventory with classification', 'Full CNAPP with runtime visibility, container/K8s coverage, and drift detection'], weights: [1,2,3,4,5] },
          { id: 'CLD-002', text: 'Are cloud control plane logs collected (CloudTrail, Activity Log, etc.)?', options: ['Not enabled or collected', 'Enabled but stored only in cloud', 'Forwarded to SIEM', 'Forwarded with custom detection rules', 'Full coverage including data plane events, with real-time alerting and historical baseline'], weights: [1,2,3,4,5] },
          { id: 'CLD-003', text: 'Do you have visibility into SaaS application usage and events?', options: ['No SaaS visibility', 'SSO logs only', 'CASB or SaaS security tool for major apps', 'Broad SaaS coverage with DLP and threat detection', 'Comprehensive SaaS security with API integration, user behavior analytics, and response capability'], weights: [1,2,3,4,5] },
          { id: 'CLD-004', text: 'If using containers, what security visibility exists?', options: ['No container visibility', 'Image scanning only', 'Runtime monitoring deployed', 'Full container security (scan, runtime, network policies)', 'Kubernetes-native security with admission control, runtime protection, and SIEM integration'], weights: [1,2,3,4,5] },
          { id: 'CLD-005', text: 'Are cloud workloads (VMs, serverless) monitored for threats?', options: ['No workload protection', 'Basic AV only', 'Cloud-native EDR/CWPP deployed', 'CWPP with vulnerability management integration', 'Full CWPP with runtime protection, file integrity, and correlation with cloud events'], weights: [1,2,3,4,5] },
        ]
      },
      {
        id: 'infrastructure',
        name: 'Enterprise Infrastructure',
        questions: [
          { id: 'INF-001', text: 'Are DHCP lease events logged and correlated?', options: ['Not logged', 'Logged locally on DHCP server', 'Forwarded to SIEM', 'Parsed and used for IP-to-host correlation', 'Integrated into entity resolution for all security events'], weights: [1,2,3,4,5] },
          { id: 'INF-002', text: 'Are Windows security events collected comprehensively?', options: ['Not collected', 'Basic security log only', 'Security, System, Application logs collected', 'Above + Sysmon deployed', 'Advanced auditing enabled (command line, PowerShell, WMI) + Sysmon with custom config'], weights: [1,2,3,4,5] },
          { id: 'INF-003', text: 'Are Linux/Unix systems logging to central SIEM?', options: ['Not collected', 'Syslog basics only', 'Auth and system logs collected', 'Auditd deployed with custom rules', 'Full audit coverage including command execution, file access, with Osquery or equivalent'], weights: [1,2,3,4,5] },
          { id: 'INF-004', text: 'Are database activities monitored for sensitive data stores?', options: ['No database monitoring', 'Native audit logging enabled', 'Logs forwarded to SIEM', 'DAM solution deployed for critical databases', 'Full DAM with query analysis, masking, and integration with DLP/SIEM'], weights: [1,2,3,4,5] },
          { id: 'INF-005', text: 'Are critical application logs collected and analyzed?', options: ['No application logging', 'Collected but not analyzed', 'Basic error/exception monitoring', 'Security-relevant app events forwarded to SIEM', 'Full app security logging with custom detection rules and correlation'], weights: [1,2,3,4,5] },
          { id: 'INF-006', text: 'Are VPN and remote access events logged and monitored?', options: ['Not logged', 'Connection logs only', 'Logs in SIEM with basic alerting', 'Correlation with user behavior and impossible travel', 'Full visibility with split-tunnel detection, anomaly detection, and automated response'], weights: [1,2,3,4,5] },
        ]
      }
    ]
  },
  {
    id: 'data_aggregation',
    name: 'Data Aggregation',
    nistFunction: 'DETECT',
    icon: 'database',
    weight: 0.10,
    description: 'Central collection, parsing, normalization, and retention',
    subsections: [
      {
        id: 'siem_architecture',
        name: 'SIEM Architecture',
        questions: [
          { id: 'AGG-001', text: 'Do you aggregate security data into a central platform?', options: ['No central aggregation', 'Some logs to a SIEM, many gaps', 'Most security logs centralized', 'Comprehensive collection with defined onboarding process', 'All security-relevant data centralized with automated source onboarding and validation'], weights: [1,2,3,4,5] },
          { id: 'AGG-002', text: 'Is your SIEM/data lake monitored for health and completeness?', options: ['No monitoring', 'Check manually when issues arise', 'Basic uptime monitoring', 'Ingestion rate monitoring with alerting on drops', 'Full observability: ingestion, parsing, latency, storage, with automated remediation'], weights: [1,2,3,4,5] },
          { id: 'AGG-003', text: 'How do you ensure expected data sources are flowing?', options: ['No validation', 'Manual spot checks', 'Monthly source inventory review', 'Automated source monitoring with alerts on missing data', 'Continuous validation with expected volume baselines and anomaly detection'], weights: [1,2,3,4,5] },
          { id: 'AGG-004', text: 'What is your typical ingestion latency (event time to searchable)?', options: ['> 15 minutes or unknown', '5-15 minutes', '1-5 minutes', '30 seconds - 1 minute', 'Near real-time (< 30 seconds) with monitoring and SLA'], weights: [1,2,3,4,5] },
          { id: 'AGG-005', text: 'Are logs normalized to a common schema?', options: ['Raw logs, no normalization', 'Some sources normalized', 'Most sources normalized to common schema', 'Comprehensive normalization with field mapping documentation', 'Full normalization with automated validation and schema enforcement'], weights: [1,2,3,4,5] },
          { id: 'AGG-006', text: 'Is data enriched during ingestion (geo, asset context, threat intel)?', options: ['No enrichment', 'Basic geo-IP only', 'Asset context (hostname, owner) added', 'Threat intel enrichment at ingest', 'Multi-source enrichment (geo, asset, user, threat intel) with lookup optimization'], weights: [1,2,3,4,5] },
        ]
      },
      {
        id: 'retention',
        name: 'Retention & Accessibility',
        questions: [
          { id: 'RET-001', text: 'How long is data searchable in your primary SIEM?', options: ['< 7 days', '7-30 days', '30-90 days', '90-180 days', '180+ days with consistent query performance'], weights: [1,2,3,4,5] },
          { id: 'RET-002', text: 'Do you retain data beyond hot storage?', options: ['No archive', 'Archives exist but not searchable', 'Searchable archive with slower performance', 'Tiered storage with defined retrieval SLAs', 'Full lifecycle management with compliance-driven retention and legal hold capability'], weights: [1,2,3,4,5] },
          { id: 'RET-003', text: 'Can analysts easily query historical data for investigations?', options: ['Only current data accessible', 'Archive requires IT request', 'Self-service archive access, slow queries', 'Unified search across hot and warm tiers', 'Seamless access across all tiers with query optimization and saved searches'], weights: [1,2,3,4,5] },
        ]
      }
    ]
  },
  {
    id: 'detection_engineering',
    name: 'Detection Engineering',
    nistFunction: 'DETECT',
    icon: 'zap',
    weight: 0.20,
    description: 'Alert strategy, RBA, fidelity, and coverage',
    subsections: [
      {
        id: 'detection_strategy',
        name: 'Detection Strategy',
        questions: [
          { id: 'DET-001', text: 'What is your overall detection strategy?', options: ['Rely on vendor defaults', 'Ad-hoc rule creation when needed', 'Defined detection roadmap', 'Threat-informed detection program aligned to ATT&CK', 'Mature detection engineering practice with lifecycle management, testing, and metrics'], weights: [1,2,3,4,5] },
          { id: 'DET-002', text: 'Do you map detections to a framework (ATT&CK, etc.)?', options: ['No mapping', 'Informal awareness of coverage', 'Initial mapping completed', 'Maintained mapping with gap analysis', 'Continuous coverage tracking with prioritized gap closure based on threat intel'], weights: [1,2,3,4,5] },
          { id: 'DET-003', text: 'How are detection rules created, tested, and maintained?', options: ['Ad-hoc, no process', 'Informal review before deployment', 'Defined process with testing', 'Full lifecycle: create, test, tune, deprecate with ownership', 'Detection-as-code with version control, CI/CD, and automated testing'], weights: [1,2,3,4,5] },
          { id: 'DET-004', text: 'Are detections validated against real attack techniques?', options: ['No testing', 'Test when issues reported', 'Periodic manual testing', 'Regular purple team or atomic testing', 'Continuous automated detection validation with coverage reporting'], weights: [1,2,3,4,5] },
          { id: 'DET-005', text: 'How do you manage false positives?', options: ['Disable noisy rules', 'Add exceptions when reported', 'Regular tuning reviews', 'FP rate tracked per rule with tuning SLA', 'Automated FP identification with guided tuning and impact analysis'], weights: [1,2,3,4,5] },
        ]
      },
      {
        id: 'rba',
        name: 'Risk-Based Alerting',
        questions: [
          { id: 'RBA-001', text: 'Do you use risk scoring to prioritize alerts?', options: ['No risk scoring', 'Severity levels only (high/medium/low)', 'Basic weighted scoring', 'Multi-factor risk scoring (asset, user, behavior)', 'Dynamic risk scoring with ML-assisted prioritization'], weights: [1,2,3,4,5] },
          { id: 'RBA-002', text: 'Is asset criticality factored into alert prioritization?', options: ['No asset context', 'Manual asset classification exists', 'Asset criticality integrated into some rules', 'Comprehensive asset scoring integrated into all alerts', 'Dynamic asset risk based on vulnerabilities, exposure, data classification, and business context'], weights: [1,2,3,4,5] },
          { id: 'RBA-003', text: 'Is user risk factored into alert prioritization?', options: ['No user context', 'Privileged vs. standard distinction', 'User risk based on role/access level', 'Behavioral baseline with anomaly weighting', 'Continuous user risk scoring integrating HR signals, access patterns, and peer comparison'], weights: [1,2,3,4,5] },
          { id: 'RBA-004', text: 'Do you establish behavioral baselines for users and entities?', options: ['No baselining', 'Basic thresholds (e.g., failed logins > 10)', 'Statistical baselines for some activities', 'UEBA tool with ML-based baselines', 'Comprehensive behavioral analytics across users, assets, and applications with peer grouping'], weights: [1,2,3,4,5] },
          { id: 'RBA-005', text: 'Can you aggregate risk across multiple low-confidence signals?', options: ['No aggregation', 'Manual correlation during investigation', 'Some correlation rules combine signals', 'Risk accumulation over time windows', 'Full risk aggregation with entity-centric risk scores and threshold-based alerting'], weights: [1,2,3,4,5] },
          { id: 'RBA-006', text: 'Do you use quantitative analysis to tune alert thresholds?', options: ['Thresholds are guesses', 'Adjust based on volume complaints', 'Review historical data before setting thresholds', 'Statistical analysis for threshold optimization', 'Data-driven threshold management with A/B testing and outcome tracking'], weights: [1,2,3,4,5] },
          { id: 'RBA-007', text: 'Do alerts include qualitative context to aid analyst decisions?', options: ['Raw data only', 'Basic field labels', 'Alert descriptions explain what triggered', 'Context includes "why it matters" guidance', 'Rich context: business impact, historical patterns, related alerts, recommended actions'], weights: [1,2,3,4,5] },
        ]
      },
      {
        id: 'fidelity',
        name: 'Alert Fidelity & Metrics',
        questions: [
          { id: 'FID-001', text: 'Do you measure true positive rates for your alerts?', options: ['No measurement', 'Anecdotal feedback', 'TP rate tracked for some rules', 'TP rate tracked for all rules with targets', 'Comprehensive fidelity metrics with automated tracking and rule scorecards'], weights: [1,2,3,4,5] },
          { id: 'FID-002', text: 'What is your alert-to-incident ratio?', options: ['> 500:1 or unknown', '200-500:1', '50-200:1', '20-50:1', '< 20:1 with continuous optimization'], weights: [1,2,3,4,5] },
          { id: 'FID-003', text: 'How do you manage overall alert volume?', options: ['No management, analysts overwhelmed', 'Suppress noisiest alerts', 'Regular volume review meetings', 'Volume targets with accountable rule owners', 'Automated volume management with smart suppression and aggregation'], weights: [1,2,3,4,5] },
          { id: 'FID-004', text: 'How often do you review detection effectiveness?', options: ['Never', 'After major incidents', 'Annually', 'Quarterly with metrics', 'Continuous with automated reporting and improvement tracking'], weights: [1,2,3,4,5] },
          { id: 'FID-005', text: 'Do you analyze incidents for missed detections?', options: ['No analysis', 'Informal discussion', 'Post-incident review includes detection gaps', 'Systematic missed detection tracking', 'Full detection gap analysis with root cause and remediation tracking'], weights: [1,2,3,4,5] },
        ]
      },
      {
        id: 'ai_threats',
        name: 'AI & Emerging Threats',
        questions: [
          { id: 'AI-001', text: 'Do you have countermeasures for AI-generated phishing and social engineering?', options: ['No specific countermeasures', 'Standard email security only', 'Enhanced email security with AI/ML detection', 'Dedicated tools for synthetic content detection', 'Multi-layered: AI phishing detection, user training on deepfakes, and verification procedures'], weights: [1,2,3,4,5], cis: [14] },
          { id: 'AI-002', text: 'Can you detect deepfake or voice clone attempts targeting your organization?', options: ['No capability', 'Rely on user awareness', 'Callback verification procedures for sensitive requests', 'Technical controls for voice/video verification', 'Comprehensive: technical detection, verification workflows, and trained staff for high-risk roles'], weights: [1,2,3,4,5], cis: [14] },
          { id: 'AI-003', text: 'Are you using AI/ML capabilities to enhance SOC detection and triage?', options: ['No AI/ML in SOC', 'Vendor-provided ML (black box)', 'ML-based anomaly detection deployed', 'AI-assisted alert prioritization and grouping', 'Comprehensive AI: auto-triage, investigation suggestions, and continuous learning from analyst feedback'], weights: [1,2,3,4,5], cis: [8] },
          { id: 'AI-004', text: 'Do you monitor for adversarial use of AI against your environment?', options: ['Not considered', 'General awareness only', 'Included in threat intel monitoring', 'Specific detections for AI-enabled attacks', 'Proactive program: AI threat modeling, detection development, and regular reassessment'], weights: [1,2,3,4,5], cis: [8] },
        ]
      }
    ]
  },
  {
    id: 'alert_routing',
    name: 'Alert Routing & Triage',
    nistFunction: 'RESPOND',
    icon: 'target',
    weight: 0.10,
    description: 'Where alerts go, prioritization, and initial handling',
    subsections: [
      {
        id: 'workflow',
        name: 'Alert Workflow',
        questions: [
          { id: 'TRI-001', text: 'Where do alerts land for analyst review?', options: ['Email only', 'Multiple consoles, no single pane', 'SIEM console as primary', 'SOAR or ticketing system as primary', 'Unified queue with prioritization, ownership, and SLA tracking'], weights: [1,2,3,4,5] },
          { id: 'TRI-002', text: 'Can analysts easily identify highest priority work?', options: ['Chronological list only', 'Severity column exists', 'Sorted/filtered by severity', 'Risk-scored queue with visual prioritization', 'Smart queue with risk score, SLA status, related alerts, and workload balancing'], weights: [1,2,3,4,5] },
          { id: 'TRI-003', text: 'How are alerts assigned to analysts?', options: ['Analysts self-select from queue', 'Round-robin or manual assignment', 'Skill-based routing', 'Automated assignment with workload balancing', 'Intelligent routing based on skill, workload, alert type, and historical performance'], weights: [1,2,3,4,5] },
          { id: 'TRI-004', text: 'Are response SLAs defined by alert severity/priority?', options: ['No SLAs', 'Informal expectations', 'SLAs defined but not enforced', 'SLAs tracked with reporting', 'SLAs enforced with escalation and tied to performance metrics'], weights: [1,2,3,4,5] },
          { id: 'TRI-005', text: 'Are alerts enriched before analyst review?', options: ['No enrichment', 'Manual enrichment by analyst', 'Some auto-enrichment (e.g., whois, geo)', 'Comprehensive auto-enrichment via SOAR', 'Full enrichment including asset, user, threat intel, historical context, and related alerts'], weights: [1,2,3,4,5] },
          { id: 'TRI-006', text: 'Are related alerts grouped or correlated?', options: ['Each alert is standalone', 'Manual correlation during investigation', 'Basic grouping by source IP or user', 'Automated clustering of related alerts', 'Intelligent case creation with ML-assisted correlation and timeline view'], weights: [1,2,3,4,5] },
        ]
      }
    ]
  },
  {
    id: 'operational_response',
    name: 'Operational Response',
    nistFunction: 'RESPOND',
    icon: 'users',
    weight: 0.20,
    description: 'SOAR, SOPs, analyst workflows, and team structure',
    subsections: [
      {
        id: 'soar',
        name: 'SOAR & Automation',
        questions: [
          { id: 'SOAR-001', text: 'Do you have a SOAR platform deployed?', options: ['No SOAR', 'SOAR purchased but not implemented', 'SOAR with basic integrations', 'SOAR fully integrated with key tools', 'Mature SOAR with broad integration, custom playbooks, and continuous development'], weights: [1,2,3,4,5] },
          { id: 'SOAR-002', text: 'What percentage of alert types have automated playbooks?', options: ['No playbooks', '< 25% coverage', '25-50% coverage', '50-75% coverage', '> 75% coverage with continuous expansion'], weights: [1,2,3,4,5] },
          { id: 'SOAR-003', text: 'What level of automation do playbooks provide?', options: ['No automation', 'Enrichment only', 'Enrichment + analyst notification', 'Auto-triage with analyst decision points', 'Full automation with conditional response and human-in-the-loop for high-risk actions'], weights: [1,2,3,4,5] },
          { id: 'SOAR-004', text: 'How many tools are integrated with SOAR?', options: ['None', '1-3 tools', '4-7 tools', '8-15 tools', '15+ tools covering endpoint, network, identity, cloud, ticketing, and comms'], weights: [1,2,3,4,5] },
          { id: 'SOAR-005', text: 'How are playbooks maintained and improved?', options: ['Set and forget', 'Fix when broken', 'Annual review', 'Quarterly review with metrics', 'Continuous improvement with version control, testing, and feedback loops'], weights: [1,2,3,4,5] },
        ]
      },
      {
        id: 'sops',
        name: 'Standard Operating Procedures',
        questions: [
          { id: 'SOP-001', text: 'Do documented SOPs exist for alert types?', options: ['No SOPs (tribal knowledge)', 'Some informal guides', 'SOPs exist for common scenarios', 'Comprehensive SOPs for all alert categories', 'Full SOP library with regular reviews and version control'], weights: [1,2,3,4,5] },
          { id: 'SOP-002', text: 'Do SOPs clearly define the ACTIONS analysts should take?', options: ['No action guidance', 'Vague directions', 'Step-by-step actions defined', 'Actions with decision trees', 'Precise actions with tool-specific instructions and screenshots'], weights: [1,2,3,4,5] },
          { id: 'SOP-003', text: 'Do SOPs explain the REASONING (why and how to think about it)?', options: ['No explanations', 'Minimal background', 'Context provided for some steps', 'Full reasoning for decisions', 'Educational content including attack context, business impact, and common pitfalls'], weights: [1,2,3,4,5] },
          { id: 'SOP-004', text: 'Do SOPs include DECISION POINTS and escalation criteria?', options: ['No decision guidance', 'Binary escalate/close', 'Some decision criteria', 'Clear decision trees with criteria', 'Comprehensive decision framework with confidence levels and escalation triggers'], weights: [1,2,3,4,5] },
          { id: 'SOP-005', text: 'Can analysts easily access relevant SOPs during investigation?', options: ['SOPs are hard to find', 'Stored in shared drive, searchable', 'Linked from SIEM/SOAR', 'Embedded in playbooks/alerts', 'Context-aware SOP suggestions with quick access from any tool'], weights: [1,2,3,4,5] },
          { id: 'SOP-006', text: 'Is there a process to improve SOPs based on analyst feedback?', options: ['No feedback mechanism', 'Informal suggestions', 'Periodic SOP reviews', 'Active feedback collection and review process', 'Continuous improvement with analyst input, incident learnings, and effectiveness tracking'], weights: [1,2,3,4,5] },
        ]
      },
      {
        id: 'team',
        name: 'Team Structure & Staffing',
        questions: [
          { id: 'TEAM-001', text: 'What is your SOC coverage model?', options: ['Business hours only', 'Extended hours (e.g., 6am-10pm)', '24x5 coverage', '24x7 with some gaps', 'True 24x7x365 with redundancy'], weights: [1,2,3,4,5], cis: [] },
          { id: 'TEAM-002', text: 'Is your SOC organized into tiers?', options: ['No tiers, everyone does everything', 'Informal skill levels', 'Defined Tier 1/2/3 with different responsibilities', 'Clear tiers with escalation paths and career progression', 'Mature structure with specializations (detection, hunting, IR, automation)'], weights: [1,2,3,4,5], cis: [] },
          { id: 'TEAM-003', text: 'Do you have adequate analyst capacity for alert volume?', options: ['Severely understaffed', 'Understaffed, alerts pile up', 'Adequate for normal volume', 'Good capacity with surge capability', 'Right-sized with automation reducing manual load, and flex capacity for incidents'], weights: [1,2,3,4,5], cis: [] },
          { id: 'TEAM-004', text: 'How are analysts trained and developed?', options: ['On-the-job only', 'Initial training, then ad-hoc', 'Regular training opportunities', 'Structured training program with certifications', 'Comprehensive development: technical, soft skills, career pathing, and threat-specific training'], weights: [1,2,3,4,5], cis: [14] },
          { id: 'TEAM-005', text: 'How is analyst knowledge captured and shared?', options: ['In peoples heads', 'Ad-hoc documentation', 'Wiki or knowledge base exists', 'Active knowledge sharing culture', 'Mature KM: searchable, maintained, integrated into workflows, with contribution incentives'], weights: [1,2,3,4,5], cis: [14] },
          { id: 'TEAM-006', text: 'Do analysts hold relevant security certifications?', options: ['No certifications required', 'Optional, self-funded', 'Certifications encouraged with partial support', 'Defined certification paths with full funding', 'Mandatory baseline certs with specialized tracks and recertification tracking'], weights: [1,2,3,4,5], cis: [14] },
          { id: 'TEAM-007', text: 'Do analysts participate in tabletop exercises or simulations?', options: ['Never', 'After major incidents only', 'Annually', 'Quarterly with rotating scenarios', 'Regular exercises including purple team, IR simulations, and cross-functional drills'], weights: [1,2,3,4,5], cis: [14, 17] },
          { id: 'TEAM-008', text: 'Is there a skills assessment and development tracking program?', options: ['No skills tracking', 'Informal awareness of skill gaps', 'Periodic skills assessments', 'Skills matrix with development plans', 'Continuous skills assessment with personalized learning paths and competency validation'], weights: [1,2,3,4,5], cis: [14] },
          { id: 'TEAM-009', text: 'Do analysts participate in CTF competitions or threat hunting challenges?', options: ['Never', 'Self-initiated by individuals', 'Occasional team participation', 'Regular internal challenges', 'Structured program with external competition and internal hunting challenges tied to real threats'], weights: [1,2,3,4,5], cis: [14] },
        ]
      }
    ]
  },
  {
    id: 'incident_management',
    name: 'Incident Management',
    nistFunction: 'RESPOND',
    icon: 'alertTriangle',
    weight: 0.10,
    description: 'Declaration, bridge/war room, roles, and communications',
    subsections: [
      {
        id: 'declaration',
        name: 'Incident Declaration',
        questions: [
          { id: 'INC-001', text: 'Are incident severity levels clearly defined?', options: ['No definitions', 'Informal understanding', 'Documented severity levels', 'Clear criteria with examples', 'Comprehensive taxonomy with severity, category, and regulatory implications'], weights: [1,2,3,4,5] },
          { id: 'INC-002', text: 'Who can declare an incident?', options: ['Only management', 'Senior analysts only', 'Any analyst with manager approval', 'Defined roles with clear authority', 'Empowered analysts with clear criteria and post-declaration validation'], weights: [1,2,3,4,5] },
          { id: 'INC-003', text: 'Are there clear criteria for when to declare an incident?', options: ['Subjective judgment', 'Informal guidelines', 'Documented thresholds', 'Clear decision tree with criteria', 'Integrated criteria in playbooks with confidence scoring'], weights: [1,2,3,4,5] },
          { id: 'INC-004', text: 'How quickly do confirmed incidents escalate to full IR?', options: ['Hours or inconsistent', '< 1 hour typically', '< 30 minutes with defined process', '< 15 minutes with automated escalation', 'Immediate activation with parallel notification and role assignment'], weights: [1,2,3,4,5] },
        ]
      },
      {
        id: 'ir_structure',
        name: 'IR Structure',
        questions: [
          { id: 'INC-005', text: 'Is there a defined process for incident bridges/war rooms?', options: ['Ad-hoc calls', 'Informal bridge process', 'Documented bridge procedures', 'Structured process with tools and templates', 'Mature process: standing bridge, role rotation, communication cadence, and documentation'], weights: [1,2,3,4,5] },
          { id: 'INC-006', text: 'Are incident response roles clearly defined?', options: ['Everyone does everything', 'Informal role assignment', 'Documented roles (IC, scribe, etc.)', 'Trained personnel for each role', 'Full RACI with backups, regular exercises, and role-specific playbooks'], weights: [1,2,3,4,5] },
          { id: 'INC-007', text: 'Is there a designated Incident Commander role?', options: ['Most senior person takes charge', 'Manager assumes IC', 'Defined IC role, informal assignment', 'Trained ICs with rotation', 'Certified IC pool with clear authority, handoff procedures, and decision rights'], weights: [1,2,3,4,5] },
          { id: 'INC-008', text: 'How is information shared during incidents?', options: ['Ad-hoc conversations', 'Email chains', 'Dedicated Slack/Teams channel', 'Structured updates with templates', 'Integrated war room with real-time documentation, stakeholder feeds, and automated status'], weights: [1,2,3,4,5] },
          { id: 'INC-009', text: 'How are stakeholders (executives, legal, etc.) kept informed?', options: ['Ad-hoc updates', 'Email when asked', 'Defined update cadence', 'Templated updates with distribution lists', 'Automated status pages with tailored views per audience and defined escalation triggers'], weights: [1,2,3,4,5] },
          { id: 'INC-010', text: 'Is there a process for external communications (customers, regulators)?', options: ['No process', 'Legal handles ad-hoc', 'Defined process with templates', 'Comms team with pre-approved messaging', 'Full crisis comms plan with legal review, regulatory timelines, and PR coordination'], weights: [1,2,3,4,5] },
        ]
      }
    ]
  },
  {
    id: 'containment_remediation',
    name: 'Containment & Remediation',
    nistFunction: 'RESPOND',
    icon: 'shield',
    weight: 0.10,
    description: 'Response capabilities, integration, evidence, and CTI',
    subsections: [
      {
        id: 'containment',
        name: 'Containment Capabilities',
        questions: [
          { id: 'CON-001', text: 'Can you isolate compromised endpoints?', options: ['Manual removal from network', 'VLAN changes via IT', 'EDR-based isolation', 'One-click isolation from SOAR', 'Automated isolation based on risk score with network verification'], weights: [1,2,3,4,5] },
          { id: 'CON-002', text: 'Can you quickly disable or reset compromised accounts?', options: ['Manual IT request', 'Direct access to AD/IdP console', 'Scripted/automated disable', 'Integrated in SOAR playbooks', 'Automated with conditional logic (disable vs. force MFA vs. monitor)'], weights: [1,2,3,4,5] },
          { id: 'CON-003', text: 'Can you block IPs/domains during incidents?', options: ['Manual firewall changes', 'Request to network team', 'Direct access to security tools', 'API-based blocking via SOAR', 'Automated blocking with threat intel integration and auto-expiration'], weights: [1,2,3,4,5] },
          { id: 'CON-004', text: 'Can you pull malicious emails from mailboxes?', options: ['No capability', 'Manual admin process', 'Email security tool capability', 'Integrated in SOAR', 'Automated retroactive pull with scope assessment and user notification'], weights: [1,2,3,4,5] },
          { id: 'CON-005', text: 'Can you remediate cloud-specific threats (revoke tokens, disable resources)?', options: ['No capability', 'Manual cloud console access', 'Scripted remediation', 'SOAR integration with cloud APIs', 'Automated cloud response with scope assessment and blast radius analysis'], weights: [1,2,3,4,5] },
        ]
      },
      {
        id: 'cti',
        name: 'Threat Intelligence',
        questions: [
          { id: 'CTI-001', text: 'Is threat intelligence integrated into response workflows?', options: ['No CTI program', 'Manual IOC lookups', 'CTI platform with analyst queries', 'Automated IOC enrichment in alerts', 'Full CTI integration: strategic, operational, and tactical intel informing all phases'], weights: [1,2,3,4,5] },
          { id: 'CTI-002', text: 'How quickly are new IOCs deployed for detection/blocking?', options: ['Not deployed', 'Days to weeks', 'Within 24 hours', 'Within hours', 'Near real-time automated deployment with confidence scoring'], weights: [1,2,3,4,5] },
          { id: 'CTI-003', text: 'Does enrichment provide actionable context?', options: ['No enrichment', 'Basic reputation scores', 'Threat actor/campaign attribution', 'TTPs and historical context', 'Full context: related incidents, kill chain position, recommended actions, and confidence'], weights: [1,2,3,4,5] },
          { id: 'CTI-004', text: 'Do incident findings feed back into threat intel?', options: ['No feedback loop', 'Informal sharing', 'IOCs shared with CTI team', 'Structured incident intel production', 'Full cycle: incidents inform intel, intel informs detection, metrics track value'], weights: [1,2,3,4,5] },
          { id: 'CTI-005', text: 'Do you utilize a dedicated Threat Intelligence Platform (TIP)?', options: ['No TIP', 'Spreadsheet or manual tracking', 'Basic TIP for IOC management', 'TIP integrated with SIEM/SOAR', 'Mature TIP: multi-source ingestion, scoring, lifecycle management, and dissemination workflows'], weights: [1,2,3,4,5] },
          { id: 'CTI-006', text: 'Do you perform proactive threat intelligence blocking?', options: ['No proactive blocking', 'Manual blocking of known-bad IOCs', 'Automated IOC blocking from feeds', 'Tiered blocking based on confidence scores', 'Full automation: confidence-scored blocking with auto-expiration and false positive feedback loop'], weights: [1,2,3,4,5] },
          { id: 'CTI-007', text: 'Do you conduct threat modeling for your organization?', options: ['No threat modeling', 'Informal understanding of threats', 'Periodic threat landscape reviews', 'Annual threat modeling with documented profiles', 'Continuous threat modeling: updated with intel, mapped to assets, and driving detection priorities'], weights: [1,2,3,4,5] },
        ]
      },
      {
        id: 'forensics',
        name: 'Evidence & Forensics',
        questions: [
          { id: 'FOR-001', text: 'Are evidence preservation procedures followed?', options: ['No procedures', 'Ad-hoc preservation', 'Documented procedures, inconsistent execution', 'Standard evidence collection integrated in playbooks', 'Automated evidence preservation with chain of custody and integrity verification'], weights: [1,2,3,4,5] },
          { id: 'FOR-002', text: 'What forensic capabilities exist in-house?', options: ['None - external only', 'Basic log analysis', 'Endpoint forensics (disk, memory)', 'Full DFIR capability', 'Advanced: malware analysis, network forensics, cloud forensics, mobile forensics'], weights: [1,2,3,4,5] },
          { id: 'FOR-003', text: 'Do analysts have access to forensic tools?', options: ['No tools', 'Open source tools, ad-hoc', 'Standard toolkit deployed', 'Integrated forensic platform', 'Comprehensive toolkit with automation, remote acquisition, and SOAR integration'], weights: [1,2,3,4,5] },
          { id: 'FOR-004', text: 'Can you construct incident timelines efficiently?', options: ['Manual log review', 'Spreadsheet-based timelines', 'SIEM-assisted timeline', 'Dedicated timeline tools', 'Automated timeline generation with entity correlation and visualization'], weights: [1,2,3,4,5] },
        ]
      }
    ]
  },
  {
    id: 'recovery_closure',
    name: 'Recovery & Closure',
    nistFunction: 'RECOVER',
    icon: 'refreshCw',
    weight: 0.05,
    description: 'ITSM integration, restore, lessons learned, and metrics',
    subsections: [
      {
        id: 'recovery',
        name: 'Recovery Operations',
        questions: [
          { id: 'REC-001', text: 'Is incident response integrated with IT service management?', options: ['No integration', 'Manual ticket creation', 'Automated ticket creation', 'Bidirectional integration', 'Full integration: incident triggers ITSM workflows, status sync, and SLA tracking'], weights: [1,2,3,4,5] },
          { id: 'REC-002', text: 'Are system restore procedures documented and tested?', options: ['No documentation', 'Informal procedures', 'Documented procedures', 'Tested annually', 'Regular testing with RTO/RPO validation and automation where possible'], weights: [1,2,3,4,5] },
          { id: 'REC-003', text: 'Are backups verified for restoration capability?', options: ['Backups exist but untested', 'Tested when needed', 'Periodic restore tests', 'Regular automated testing', 'Continuous validation with immutability verification and ransomware-specific scenarios'], weights: [1,2,3,4,5] },
          { id: 'REC-004', text: 'Is there coordination with business continuity for major incidents?', options: ['No coordination', 'Ad-hoc involvement', 'BC team engaged for major incidents', 'Integrated IR and BC processes', 'Unified resilience program with joint exercises and playbooks'], weights: [1,2,3,4,5] },
        ]
      },
      {
        id: 'pir',
        name: 'Post-Incident Process',
        questions: [
          { id: 'PIR-001', text: 'Are post-incident reviews conducted?', options: ['No PIRs', 'After major incidents only', 'Standard PIR for all incidents', 'Structured PIR with templates and facilitation', 'Blameless PIRs with action tracking and effectiveness measurement'], weights: [1,2,3,4,5] },
          { id: 'PIR-002', text: 'Are lessons learned tracked to completion?', options: ['Not tracked', 'Documented but not tracked', 'Tracked in separate system', 'Tracked with ownership and deadlines', 'Integrated tracking with metrics, executive visibility, and closure verification'], weights: [1,2,3,4,5] },
          { id: 'PIR-003', text: 'Do incidents drive detection improvements?', options: ['No feedback to detection', 'Informal suggestions', 'Detection gaps noted in PIR', 'Formal detection improvement requests', 'Systematic gap-to-detection pipeline with coverage tracking'], weights: [1,2,3,4,5] },
          { id: 'PIR-004', text: 'Do incidents drive control/prevention improvements?', options: ['No feedback to controls', 'Ad-hoc recommendations', 'PIR includes control recommendations', 'Formal remediation tracking', 'Risk-based prioritization with control effectiveness measurement'], weights: [1,2,3,4,5] },
        ]
      },
      {
        id: 'metrics',
        name: 'Metrics & Reporting',
        questions: [
          { id: 'MET-001', text: 'Do you track core SOC operational metrics?', options: ['No metrics', 'Basic volume counts', 'MTTD, MTTA, MTTR tracked', 'Comprehensive metrics dashboard', 'Full metrics program: trends, targets, benchmarking, and improvement tracking'], weights: [1,2,3,4,5] },
          { id: 'MET-002', text: 'Do you measure detection effectiveness?', options: ['No detection metrics', 'Rule trigger counts', 'TP/FP rates tracked', 'Coverage and efficacy metrics', 'Detection engineering KPIs with outcome correlation'], weights: [1,2,3,4,5] },
          { id: 'MET-003', text: 'Is SOC performance reported to leadership?', options: ['No reporting', 'Ad-hoc when asked', 'Monthly operational report', 'Executive dashboard with business context', 'Strategic reporting: risk posture, trends, benchmarks, and investment recommendations'], weights: [1,2,3,4,5] },
          { id: 'MET-004', text: 'Is there a formal continuous improvement program?', options: ['No program', 'React to issues', 'Annual improvement planning', 'Quarterly improvement cycles', 'Mature program: metrics-driven, resourced, tracked, and tied to strategy'], weights: [1,2,3,4,5] },
          { id: 'MET-005', text: 'Do you track granular time-based metrics (MTTD, MTTI, MTTC separately)?', options: ['No granular metrics', 'Overall MTTR only', 'MTTD and MTTR tracked', 'MTTD, MTTI, MTTC tracked separately', 'Full breakdown with targets, trends, and root cause analysis for outliers'], weights: [1,2,3,4,5] },
          { id: 'MET-006', text: 'Do you measure detection quality metrics per rule or use case?', options: ['No per-rule metrics', 'Volume counts per rule', 'TP/FP rates for some rules', 'TP/FP rates for all rules with thresholds', 'Per-rule scorecards: fidelity, MTTD contribution, tuning history, and retirement criteria'], weights: [1,2,3,4,5] },
          { id: 'MET-007', text: 'Do you have metrics to justify SOC staffing and investment?', options: ['No staffing metrics', 'Headcount only', 'Alert volume per analyst tracked', 'Workload metrics with capacity planning', 'Full model: cost per incident, automation ROI, coverage gaps, and investment recommendations'], weights: [1,2,3,4,5] },
        ]
      }
    ]
  },
  {
    id: 'proactive_security',
    name: 'Proactive Security',
    nistFunction: 'IDENTIFY/PROTECT',
    icon: 'eye',
    weight: 0.05,
    description: 'Vulnerability management, application security, and adversary simulation',
    subsections: [
      {
        id: 'vuln_management',
        name: 'Vulnerability Management',
        questions: [
          { id: 'VUL-001', text: 'What is your vulnerability scanning coverage?', options: ['No regular scanning', 'Perimeter systems only', 'Critical systems scanned monthly', 'All systems scanned weekly', 'Continuous scanning with authenticated scans and agent-based coverage'], weights: [1,2,3,4,5], cis: [7] },
          { id: 'VUL-002', text: 'How do you prioritize vulnerabilities for remediation?', options: ['CVSS score only', 'CVSS with manual review', 'CVSS plus asset criticality', 'Risk-based prioritization with exploit intelligence', 'Dynamic prioritization: CVSS + asset value + exploit availability + business context'], weights: [1,2,3,4,5], cis: [7] },
          { id: 'VUL-003', text: 'Are vulnerability findings integrated with your SOC workflow?', options: ['No integration', 'Manual reports shared periodically', 'Critical vulns create alerts', 'Vuln data enriches security alerts', 'Full integration: vuln context in incidents, exploited vuln detection, and patch verification'], weights: [1,2,3,4,5], cis: [7] },
          { id: 'VUL-004', text: 'Do you have defined SLAs for vulnerability remediation?', options: ['No SLAs', 'Informal expectations', 'SLAs for critical only', 'Tiered SLAs by severity', 'Risk-based SLAs with exception process, escalation, and compliance tracking'], weights: [1,2,3,4,5], cis: [7] },
          { id: 'VUL-005', text: 'How do you handle vulnerabilities that cannot be immediately patched?', options: ['Accept the risk informally', 'Document in spreadsheet', 'Formal risk acceptance process', 'Compensating controls with monitoring', 'Full exception management: compensating controls, enhanced monitoring, expiration, and re-review'], weights: [1,2,3,4,5], cis: [7] },
        ]
      },
      {
        id: 'appsec',
        name: 'Application Security',
        questions: [
          { id: 'APP-001', text: 'Do you have visibility into application security findings (SAST/DAST)?', options: ['No AppSec program', 'Developers handle independently', 'Security reviews select applications', 'SAST/DAST in CI/CD for critical apps', 'Comprehensive AppSec: SAST, DAST, SCA, IAST with SOC visibility into critical findings'], weights: [1,2,3,4,5], cis: [16] },
          { id: 'APP-002', text: 'Are critical AppSec findings routed to the SOC?', options: ['No routing to SOC', 'Ad-hoc escalation for major issues', 'Critical findings create tickets', 'Real-time alerts for exploitable vulns', 'Integrated workflow: AppSec findings enrich detection, and SOC monitors exploitation attempts'], weights: [1,2,3,4,5], cis: [16] },
          { id: 'APP-003', text: 'Can you detect exploitation attempts against known application vulnerabilities?', options: ['No detection capability', 'WAF with default rules', 'WAF with custom rules for CVEs', 'WAF + RASP with alerting', 'Full stack: WAF, RASP, behavioral analysis with correlation to AppSec findings'], weights: [1,2,3,4,5], cis: [16] },
          { id: 'APP-004', text: 'Is there collaboration between AppSec, DevOps, and SOC teams?', options: ['Siloed teams', 'Ad-hoc communication', 'Regular sync meetings', 'Shared tools and dashboards', 'Integrated DevSecOps with shared responsibility, joint exercises, and unified metrics'], weights: [1,2,3,4,5], cis: [16] },
        ]
      },
      {
        id: 'purple_team',
        name: 'Adversary Simulation',
        questions: [
          { id: 'PUR-001', text: 'Do you conduct penetration testing?', options: ['Never', 'After major incidents', 'Annually for compliance', 'Annual plus major changes', 'Continuous testing with rotating scope and red team engagements'], weights: [1,2,3,4,5], cis: [18] },
          { id: 'PUR-002', text: 'Do penetration test findings drive detection improvements?', options: ['No connection to detection', 'Findings shared with SOC', 'Critical findings trigger detection review', 'All findings mapped to detection gaps', 'Systematic: pen test TTPs become detection validation cases'], weights: [1,2,3,4,5], cis: [18] },
          { id: 'PUR-003', text: 'Do you conduct purple team exercises?', options: ['No purple team', 'Ad-hoc coordination with pen testers', 'Annual purple team exercise', 'Quarterly purple team with defined objectives', 'Continuous purple team: regular exercises, detection validation, and coverage improvement'], weights: [1,2,3,4,5], cis: [18] },
          { id: 'PUR-004', text: 'Do you use breach and attack simulation (BAS) tools?', options: ['No BAS capability', 'Manual atomic tests occasionally', 'BAS tool deployed, run periodically', 'Automated BAS with scheduled campaigns', 'Continuous BAS with detection coverage reporting and automated gap identification'], weights: [1,2,3,4,5], cis: [18] },
          { id: 'PUR-005', text: 'How do you validate detection coverage against ATT&CK?', options: ['No validation', 'Informal awareness of gaps', 'Annual manual assessment', 'Quarterly validation with testing', 'Continuous validation: automated testing, coverage metrics, and prioritized gap closure'], weights: [1,2,3,4,5], cis: [18] },
          { id: 'PUR-006', text: 'Are red/purple team findings tracked to remediation?', options: ['Not tracked', 'Shared in reports', 'Tracked in spreadsheet', 'Tracked with ownership and deadlines', 'Full lifecycle: finding to detection to validation with effectiveness measurement'], weights: [1,2,3,4,5], cis: [18] },
        ]
      },
      {
        id: 'threat_hunting',
        name: 'Threat Hunting',
        questions: [
          { id: 'HUNT-001', text: 'Do you have a dedicated threat hunting program?', options: ['No hunting capability', 'Ad-hoc hunting when time permits', 'Defined hunting program with assigned personnel', 'Structured program with regular cadence and objectives', 'Mature program: hypothesis-driven, resourced, with metrics and continuous improvement'], weights: [1,2,3,4,5], cis: [18] },
          { id: 'HUNT-002', text: 'How are threat hunts initiated and prioritized?', options: ['Reactive only (after incidents)', 'Based on analyst curiosity', 'Informed by threat intel feeds', 'Hypothesis-driven based on threat profiles', 'Risk-prioritized using threat modeling, intel, and ATT&CK gap analysis'], weights: [1,2,3,4,5], cis: [18] },
          { id: 'HUNT-003', text: 'Are threat hunt findings documented and tracked?', options: ['No documentation', 'Informal notes', 'Documented in shared drive', 'Tracked in project management tool or kanban', 'Full repository: methodology, findings, IOCs, detection recommendations, and outcomes'], weights: [1,2,3,4,5], cis: [18] },
          { id: 'HUNT-004', text: 'Do threat hunts result in new detections or detection improvements?', options: ['No connection to detection', 'Findings shared informally', 'Some hunts result in new rules', 'Formal hunt-to-detection pipeline', 'Systematic: all hunts evaluated for detection opportunities with coverage tracking'], weights: [1,2,3,4,5], cis: [18] },
          { id: 'HUNT-005', text: 'What is your threat hunting cadence?', options: ['No regular cadence', 'Quarterly or less', 'Monthly', 'Bi-weekly', 'Weekly or continuous with surge capability for emerging threats'], weights: [1,2,3,4,5], cis: [18] },
          { id: 'HUNT-006', text: 'Do you maintain threat profiles for relevant adversaries?', options: ['No threat profiles', 'General awareness of threat landscape', 'Industry threat reports reviewed', 'Documented profiles for top threat actors', 'Maintained profiles with TTPs mapped to your environment and detection coverage'], weights: [1,2,3,4,5], cis: [18] },
        ]
      }
    ]
  }
];

const getMaturityLevel = (score) => {
  if (score >= 80) return { level: 'Optimized', color: '#22c55e', description: 'Continuous improvement with industry-leading capabilities' };
  if (score >= 60) return { level: 'Managed', color: '#84cc16', description: 'Measured, controlled, and actively improving' };
  if (score >= 40) return { level: 'Defined', color: '#eab308', description: 'Documented processes, generally followed' };
  if (score >= 20) return { level: 'Developing', color: '#f97316', description: 'Basic capabilities emerging, inconsistent' };
  return { level: 'Initial', color: '#ef4444', description: 'Ad-hoc, reactive, undocumented' };
};

// CIS Controls v8 Definitions
const cisControls = {
  1: { name: 'Enterprise Asset Inventory', description: 'Actively manage all enterprise assets' },
  2: { name: 'Software Asset Inventory', description: 'Actively manage all software on the network' },
  3: { name: 'Data Protection', description: 'Develop processes to identify, classify, and protect data' },
  4: { name: 'Secure Configuration', description: 'Establish secure configurations for assets' },
  5: { name: 'Account Management', description: 'Use processes to manage credentials and accounts' },
  6: { name: 'Access Control', description: 'Use processes to create and manage access privileges' },
  7: { name: 'Vulnerability Management', description: 'Continuously identify and remediate vulnerabilities' },
  8: { name: 'Audit Log Management', description: 'Collect, alert, review, and retain audit logs' },
  9: { name: 'Email & Web Protections', description: 'Improve protections and detections for email and web threats' },
  10: { name: 'Malware Defenses', description: 'Prevent or control installation of malicious software' },
  11: { name: 'Data Recovery', description: 'Establish processes to recover enterprise assets' },
  12: { name: 'Network Infrastructure', description: 'Establish and maintain secure network infrastructure' },
  13: { name: 'Network Monitoring', description: 'Operate processes to monitor and defend network infrastructure' },
  14: { name: 'Security Awareness Training', description: 'Establish a security awareness program' },
  15: { name: 'Service Provider Management', description: 'Develop processes to manage service providers' },
  16: { name: 'Application Security', description: 'Manage the security lifecycle of developed or acquired software' },
  17: { name: 'Incident Response', description: 'Establish an incident response program' },
  18: { name: 'Penetration Testing', description: 'Test effectiveness through simulated attacks' },
};

// Question to CIS Control mapping (for questions without inline cis property)
const questionCISMapping = {
  // Detection Surface - Asset Inventory (CIS 1), Malware Defenses (CIS 10)
  'EDR-001': [1, 10], 'EDR-002': [10], 'EDR-003': [4, 10], 'EDR-004': [10], 'EDR-005': [4, 10], 'EDR-006': [8, 10], 'EDR-007': [10, 17],
  // Network (CIS 12, 13)
  'NET-001': [8, 12], 'NET-002': [13], 'NET-003': [13], 'NET-004': [9, 13], 'NET-005': [9, 13], 'NET-006': [9], 'NET-007': [12, 13],
  // Identity (CIS 5, 6)
  'IAM-001': [5, 8], 'IAM-002': [5, 6], 'IAM-003': [5], 'IAM-004': [5, 6], 'IAM-005': [5, 6], 'IAM-006': [5, 8],
  // Cloud (CIS 1, 2)
  'CLD-001': [1, 2], 'CLD-002': [8], 'CLD-003': [2, 8], 'CLD-004': [1, 10], 'CLD-005': [10],
  // Infrastructure (CIS 1, 8)
  'INF-001': [1], 'INF-002': [8], 'INF-003': [8], 'INF-004': [3, 8], 'INF-005': [8], 'INF-006': [6, 8],
  // Data Aggregation (CIS 8)
  'AGG-001': [8], 'AGG-002': [8], 'AGG-003': [8], 'AGG-004': [8], 'AGG-005': [8], 'AGG-006': [8],
  'RET-001': [8], 'RET-002': [8, 11], 'RET-003': [8],
  // Detection Engineering (CIS 13, 17)
  'DET-001': [13], 'DET-002': [13], 'DET-003': [13], 'DET-004': [13, 18], 'DET-005': [13],
  'RBA-001': [13], 'RBA-002': [1, 13], 'RBA-003': [5, 13], 'RBA-004': [13], 'RBA-005': [13], 'RBA-006': [13], 'RBA-007': [13],
  'FID-001': [13], 'FID-002': [13], 'FID-003': [13], 'FID-004': [13], 'FID-005': [13, 17],
  // AI & Emerging Threats (CIS 8, 14)
  'AI-001': [14], 'AI-002': [14], 'AI-003': [8], 'AI-004': [8],
  // Alert Routing (CIS 17)
  'TRI-001': [17], 'TRI-002': [17], 'TRI-003': [17], 'TRI-004': [17], 'TRI-005': [17], 'TRI-006': [17],
  // SOAR (CIS 17)
  'SOAR-001': [17], 'SOAR-002': [17], 'SOAR-003': [17], 'SOAR-004': [17], 'SOAR-005': [17],
  // SOPs (CIS 17)
  'SOP-001': [17], 'SOP-002': [17], 'SOP-003': [17], 'SOP-004': [17], 'SOP-005': [17], 'SOP-006': [17],
  // Incident Management (CIS 17)
  'INC-001': [17], 'INC-002': [17], 'INC-003': [17], 'INC-004': [17], 'INC-005': [17], 'INC-006': [17], 'INC-007': [17], 'INC-008': [17], 'INC-009': [17], 'INC-010': [17],
  // Containment (CIS 10, 17)
  'CON-001': [10, 17], 'CON-002': [17], 'CON-003': [10, 17], 'CON-004': [17],
  // CTI (CIS 13)
  'CTI-001': [13], 'CTI-002': [13], 'CTI-003': [13], 'CTI-004': [13], 'CTI-005': [13], 'CTI-006': [13], 'CTI-007': [13],
  // Forensics (CIS 17)
  'FOR-001': [17], 'FOR-002': [17], 'FOR-003': [17], 'FOR-004': [17],
  // Recovery (CIS 11, 17)
  'REC-001': [11, 17], 'REC-002': [11], 'REC-003': [11, 17], 'REC-004': [11, 17],
  // PIR (CIS 17)
  'PIR-001': [17], 'PIR-002': [17], 'PIR-003': [13, 17], 'PIR-004': [17],
  // Metrics (CIS 17)
  'MET-001': [17], 'MET-002': [13], 'MET-003': [17], 'MET-004': [17], 'MET-005': [17], 'MET-006': [13, 17], 'MET-007': [17],
  // Threat Hunting (CIS 18)
  'HUNT-001': [18], 'HUNT-002': [18], 'HUNT-003': [18], 'HUNT-004': [18], 'HUNT-005': [18], 'HUNT-006': [18],
  // 3rd Party (CIS 15)
  'TPR-001': [15], 'TPR-002': [15], 'TPR-003': [15], 'TPR-004': [15], 'TPR-005': [15],
};

// Professional recommendations for each question - org guidance + solutions
const questionRecommendations = {
  // === DETECTION SURFACE: EDR ===
  'EDR-001': {
    priority: 'High',
    orgGuidance: 'Establish a formal EDR deployment policy requiring coverage across all endpoint types. Create an asset inventory reconciliation process to identify coverage gaps. Set deployment targets with executive sponsorship and track progress weekly.',
    freeSolution: 'Wazuh (open-source EDR/XDR), OSSEC, Velociraptor for endpoint visibility',
    vendorSolution: 'CrowdStrike Falcon, Microsoft Defender for Endpoint, SentinelOne, Carbon Black'
  },
  'EDR-002': {
    priority: 'High',
    orgGuidance: 'Enable full telemetry collection including process creation, network connections, file modifications, and registry changes. Document telemetry requirements and validate collection completeness quarterly.',
    freeSolution: 'Sysmon with SwiftOnSecurity config, Wazuh agents, osquery',
    vendorSolution: 'CrowdStrike Falcon Insight, Microsoft Defender ATP, Elastic Security'
  },
  'EDR-003': {
    priority: 'Moderate',
    orgGuidance: 'Implement tamper protection policies preventing endpoint users and malware from disabling security tools. Test tamper protection monthly using authorized red team techniques.',
    freeSolution: 'Windows Defender Tamper Protection (built-in), SELinux/AppArmor for Linux',
    vendorSolution: 'CrowdStrike Falcon Prevent, SentinelOne Vigilance, Carbon Black App Control'
  },
  'EDR-004': {
    priority: 'High',
    orgGuidance: 'Configure behavioral detection rules to identify living-off-the-land techniques, fileless malware, and credential theft. Update behavioral baselines after major application deployments.',
    freeSolution: 'Sigma rules with Wazuh, YARA rules, Sysmon + ELK behavioral detection',
    vendorSolution: 'CrowdStrike Falcon OverWatch, SentinelOne Storyline, Microsoft Defender AI'
  },
  'EDR-005': {
    priority: 'Moderate',
    orgGuidance: 'Develop custom detection rules aligned with your threat profile. Map detections to MITRE ATT&CK and prioritize based on adversary techniques targeting your industry.',
    freeSolution: 'Sigma rule development, YARA custom rules, Velociraptor artifacts',
    vendorSolution: 'CrowdStrike Falcon X custom IOCs, SentinelOne Deep Visibility queries'
  },
  'EDR-006': {
    priority: 'High',
    orgGuidance: 'Integrate EDR telemetry with your SIEM for correlation and long-term retention. Ensure real-time streaming with minimal latency for time-sensitive detections.',
    freeSolution: 'Wazuh + OpenSearch, Velociraptor + Elastic, osquery + Fleet',
    vendorSolution: 'CrowdStrike Falcon Data Replicator, Microsoft Sentinel integration, Splunk UBA'
  },
  'EDR-007': {
    priority: 'High',
    orgGuidance: 'Enable automated response capabilities including host isolation, process termination, and file quarantine. Define escalation criteria and test response automation quarterly.',
    freeSolution: 'Wazuh active response, TheHive + Cortex automation, Shuffle SOAR',
    vendorSolution: 'CrowdStrike Falcon Real Time Response, SentinelOne RemoteOps, Microsoft Live Response'
  },
  // === DETECTION SURFACE: Network ===
  'NET-001': {
    priority: 'High',
    orgGuidance: 'Deploy network traffic analysis at critical network boundaries including internet egress, data center interconnects, and cloud VPC boundaries. Capture NetFlow/IPFIX at minimum.',
    freeSolution: 'Zeek (formerly Bro), Suricata, ntopng, Arkime (Moloch)',
    vendorSolution: 'Darktrace, Vectra AI, ExtraHop Reveal(x), Cisco Secure Network Analytics'
  },
  'NET-002': {
    priority: 'High',
    orgGuidance: 'Implement DNS logging and analysis to detect C2 communications, data exfiltration, and malicious domain resolution. Block known malicious domains and monitor for DGA patterns.',
    freeSolution: 'Pi-hole with logging, Zeek DNS analysis, PassiveDNS, RITA',
    vendorSolution: 'Cisco Umbrella, Infoblox BloxOne, Palo Alto DNS Security, Zscaler'
  },
  'NET-003': {
    priority: 'Moderate',
    orgGuidance: 'Deploy TLS/SSL inspection at network boundaries to detect threats in encrypted traffic. Implement certificate pinning exceptions and privacy-sensitive bypass lists.',
    freeSolution: 'Zeek SSL analysis, PolarProxy, mitmproxy for testing',
    vendorSolution: 'Palo Alto SSL Decryption, Zscaler SSL Inspection, F5 SSL Orchestrator'
  },
  'NET-004': {
    priority: 'High',
    orgGuidance: 'Monitor web proxy logs for malicious URLs, suspicious user agents, and anomalous browsing patterns. Implement URL categorization and block uncategorized sites.',
    freeSolution: 'Squid proxy with logging, Zeek HTTP analysis, ELSA',
    vendorSolution: 'Zscaler Internet Access, Palo Alto URL Filtering, Cisco Secure Web Appliance'
  },
  'NET-005': {
    priority: 'High',
    orgGuidance: 'Analyze email headers, attachments, and URLs for malicious content. Implement DMARC, DKIM, and SPF to reduce spoofing. Sandbox suspicious attachments.',
    freeSolution: 'Rspamd, SpamAssassin, ClamAV, ThePhish for phishing analysis',
    vendorSolution: 'Proofpoint, Mimecast, Microsoft Defender for Office 365, Abnormal Security'
  },
  'NET-006': {
    priority: 'Moderate',
    orgGuidance: 'Implement web application firewall logging and integrate with SIEM. Monitor for OWASP Top 10 attacks and create custom rules for application-specific threats.',
    freeSolution: 'ModSecurity with OWASP CRS, NAXSI, Coraza WAF',
    vendorSolution: 'Cloudflare WAF, AWS WAF, Imperva, F5 Advanced WAF'
  },
  'NET-007': {
    priority: 'Moderate',
    orgGuidance: 'Segment networks based on data sensitivity and asset criticality. Implement micro-segmentation for crown jewel systems and monitor cross-segment traffic.',
    freeSolution: 'pfSense, OPNsense, Linux iptables/nftables, Open vSwitch',
    vendorSolution: 'Illumio, Guardicore (Akamai), VMware NSX, Cisco ACI'
  },
  // === DETECTION SURFACE: Identity ===
  'IAM-001': {
    priority: 'High',
    orgGuidance: 'Centralize authentication logging from all identity providers. Monitor for impossible travel, credential stuffing, and brute force attacks. Implement real-time alerting.',
    freeSolution: 'Keycloak with audit logging, FreeIPA, OpenLDAP audit logs',
    vendorSolution: 'Okta, Azure AD, Ping Identity, CyberArk Identity'
  },
  'IAM-002': {
    priority: 'High',
    orgGuidance: 'Monitor privileged account usage including service accounts, admin accounts, and break-glass credentials. Implement just-in-time access and session recording.',
    freeSolution: 'Teleport, HashiCorp Boundary, sudo logging, auditd',
    vendorSolution: 'CyberArk PAM, BeyondTrust, Delinea (Thycotic), HashiCorp Vault Enterprise'
  },
  'IAM-003': {
    priority: 'High',
    orgGuidance: 'Implement MFA across all user accounts with phishing-resistant methods for privileged users. Monitor MFA bypass attempts and enrollment anomalies.',
    freeSolution: 'Authelia, privacyIDEA, LinOTP, Duo Free tier',
    vendorSolution: 'Duo Security, Okta Verify, Microsoft Authenticator, YubiKey'
  },
  'IAM-004': {
    priority: 'High',
    orgGuidance: 'Deploy UEBA to detect compromised accounts through behavioral analysis. Baseline normal user activity and alert on statistical anomalies.',
    freeSolution: 'Apache Spot, RITA for network UEBA, Wazuh user monitoring',
    vendorSolution: 'Microsoft Sentinel UEBA, Exabeam, Securonix, Splunk UBA'
  },
  'IAM-005': {
    priority: 'Moderate',
    orgGuidance: 'Integrate HR systems with identity providers for automated provisioning/deprovisioning. Implement access certification reviews quarterly.',
    freeSolution: 'Apache Syncope, Midpoint, LDAP sync scripts',
    vendorSolution: 'SailPoint, Saviynt, One Identity, Microsoft Entra ID Governance'
  },
  'IAM-006': {
    priority: 'High',
    orgGuidance: 'Monitor service account usage patterns and detect credential exposure. Implement service account rotation and eliminate interactive logon capabilities.',
    freeSolution: 'HashiCorp Vault, LAPS for Windows, custom rotation scripts',
    vendorSolution: 'CyberArk, Delinea, HashiCorp Vault Enterprise, AWS Secrets Manager'
  },
  // === DETECTION SURFACE: Cloud ===
  'CLD-001': {
    priority: 'High',
    orgGuidance: 'Enable cloud audit logging across all cloud providers (CloudTrail, Azure Activity Log, GCP Audit Logs). Centralize logs and retain for minimum 1 year.',
    freeSolution: 'Cloud-native logging + OpenSearch, Grafana Loki, Graylog',
    vendorSolution: 'Splunk Cloud, Datadog, Sumo Logic, Panther'
  },
  'CLD-002': {
    priority: 'High',
    orgGuidance: 'Implement CSPM to continuously assess cloud configurations against security benchmarks (CIS, NIST). Remediate critical findings within 24 hours.',
    freeSolution: 'Prowler, ScoutSuite, CloudSploit, Steampipe',
    vendorSolution: 'Wiz, Orca Security, Prisma Cloud, Lacework'
  },
  'CLD-003': {
    priority: 'High',
    orgGuidance: 'Monitor cloud workloads for runtime threats including container escapes, cryptomining, and lateral movement. Implement cloud-native network policies.',
    freeSolution: 'Falco, Tracee, Tetragon, Cilium with Hubble',
    vendorSolution: 'Aqua Security, Sysdig, Prisma Cloud Compute, Lacework'
  },
  'CLD-004': {
    priority: 'Moderate',
    orgGuidance: 'Inventory all cloud assets including shadow IT through CASB and cloud-native discovery. Track asset ownership and apply security controls uniformly.',
    freeSolution: 'CloudQuery, Cartography, cloud-nuke for inventory, Infracost',
    vendorSolution: 'Wiz, Orca, ServiceNow Cloud Management, Flexera'
  },
  'CLD-005': {
    priority: 'Moderate',
    orgGuidance: 'Implement cloud-native threat detection using provider services and third-party CNAPP. Monitor for IAM privilege escalation and resource hijacking.',
    freeSolution: 'AWS GuardDuty (partial free), Falco, CloudTrail analysis scripts',
    vendorSolution: 'AWS GuardDuty, Azure Defender, GCP Security Command Center, Wiz'
  },
  // === DETECTION SURFACE: Infrastructure ===
  'INF-001': {
    priority: 'High',
    orgGuidance: 'Maintain a comprehensive asset inventory synchronized with CMDB. Include hardware, software, and configuration details. Reconcile weekly against network scans.',
    freeSolution: 'Snipe-IT, NetBox, GLPI, Ralph, Ansible inventory',
    vendorSolution: 'ServiceNow CMDB, Qualys Asset Inventory, Axonius, runZero'
  },
  'INF-002': {
    priority: 'High',
    orgGuidance: 'Collect logs from all infrastructure components including servers, databases, and network devices. Standardize log formats and ensure timestamp accuracy.',
    freeSolution: 'rsyslog, Fluentd, Vector, Filebeat + ELK',
    vendorSolution: 'Splunk Universal Forwarder, Cribl, LogRhythm, Graylog Enterprise'
  },
  'INF-003': {
    priority: 'Moderate',
    orgGuidance: 'Monitor database activity including queries, schema changes, and privileged operations. Implement data masking and detect sensitive data access.',
    freeSolution: 'pgAudit (PostgreSQL), MySQL Enterprise Audit, MongoDB profiler',
    vendorSolution: 'Imperva Data Security, IBM Guardium, Oracle Audit Vault'
  },
  'INF-004': {
    priority: 'High',
    orgGuidance: 'Implement DLP monitoring for sensitive data movement across email, web, and endpoints. Classify data and create policies aligned with regulatory requirements.',
    freeSolution: 'OpenDLP, MyDLP, custom regex patterns in proxy/SIEM',
    vendorSolution: 'Microsoft Purview, Symantec DLP, Digital Guardian, Forcepoint'
  },
  'INF-005': {
    priority: 'Moderate',
    orgGuidance: 'Monitor physical security systems including badge access, cameras, and environmental controls. Correlate physical access with logical access for insider threat detection.',
    freeSolution: 'ZoneMinder (cameras), custom badge log integration',
    vendorSolution: 'Genetec, Honeywell, Lenel, Verkada'
  },
  'INF-006': {
    priority: 'Moderate',
    orgGuidance: 'Monitor OT/ICS environments separately from IT with appropriate protocols and tools. Implement network segmentation between IT and OT.',
    freeSolution: 'Zeek for OT protocols, Malcolm, Grassmarlin',
    vendorSolution: 'Claroty, Nozomi Networks, Dragos, Forescout'
  },
  // === DATA AGGREGATION ===
  'AGG-001': {
    priority: 'High',
    orgGuidance: 'Deploy a centralized SIEM platform capable of ingesting, normalizing, and correlating security events. Size for 90-day hot storage minimum.',
    freeSolution: 'Wazuh, Security Onion, ELK Stack, Graylog',
    vendorSolution: 'Splunk Enterprise Security, Microsoft Sentinel, IBM QRadar, LogRhythm'
  },
  'AGG-002': {
    priority: 'High',
    orgGuidance: 'Normalize log data to a common schema (ECS, OCSF, CEF) for consistent detection rule development. Document field mappings for all log sources.',
    freeSolution: 'Elastic Common Schema, OCSF with custom parsers, Logstash',
    vendorSolution: 'Splunk CIM, Chronicle YARA-L, Cribl Stream'
  },
  'AGG-003': {
    priority: 'Moderate',
    orgGuidance: 'Implement data enrichment pipelines adding threat intelligence, asset context, and user information to events at ingest time.',
    freeSolution: 'MISP enrichment, MaxMind GeoIP, custom lookup tables',
    vendorSolution: 'Splunk ES Asset/Identity, Recorded Future, ThreatConnect'
  },
  'AGG-004': {
    priority: 'High',
    orgGuidance: 'Correlate events across multiple data sources to detect complex attack patterns. Implement behavioral analytics and statistical anomaly detection.',
    freeSolution: 'Sigma rules, ElastAlert, Wazuh correlation rules',
    vendorSolution: 'Splunk ES correlation, Microsoft Sentinel Fusion, Exabeam'
  },
  'AGG-005': {
    priority: 'Moderate',
    orgGuidance: 'Develop dashboards and visualizations for SOC analysts, management, and executives. Include operational metrics and threat landscape views.',
    freeSolution: 'Grafana, Kibana, Apache Superset',
    vendorSolution: 'Splunk dashboards, Microsoft Sentinel Workbooks, Datadog'
  },
  'AGG-006': {
    priority: 'Moderate',
    orgGuidance: 'Implement SIEM health monitoring to detect collection gaps, parsing failures, and capacity issues. Alert on data source outages within 15 minutes.',
    freeSolution: 'Custom health dashboards, Prometheus + Grafana, Elastalert',
    vendorSolution: 'Splunk Monitoring Console, Cribl monitoring, vendor support'
  },
  // === DATA RETENTION ===
  'RET-001': {
    priority: 'High',
    orgGuidance: 'Define log retention policy aligned with regulatory requirements (PCI: 1 year, HIPAA: 6 years, etc.). Implement tiered storage for cost optimization.',
    freeSolution: 'S3 lifecycle policies, MinIO, tape archival',
    vendorSolution: 'Splunk SmartStore, Chronicle, Snowflake, AWS S3 Glacier'
  },
  'RET-002': {
    priority: 'Moderate',
    orgGuidance: 'Implement searchable archives for forensic investigations. Ensure archived data can be restored and searched within 4 hours.',
    freeSolution: 'Elasticsearch frozen tier, S3 + Athena, ClickHouse',
    vendorSolution: 'Splunk Archive, Chronicle, Panther, Matano'
  },
  'RET-003': {
    priority: 'Moderate',
    orgGuidance: 'Ensure log integrity through immutable storage, cryptographic hashing, or write-once media. Document chain of custody procedures.',
    freeSolution: 'S3 Object Lock, WORM storage, hashdeep verification',
    vendorSolution: 'AWS S3 Object Lock, Azure Immutable Blob, NetApp WORM'
  },
  // === DETECTION ENGINEERING ===
  'DET-001': {
    priority: 'High',
    orgGuidance: 'Establish a detection engineering function responsible for developing, testing, and tuning detection rules. Track detection coverage using MITRE ATT&CK.',
    freeSolution: 'Sigma rules, Atomic Red Team testing, DeTT&CT',
    vendorSolution: 'Splunk Security Essentials, Anvilogic, CardinalOps, SOC Prime'
  },
  'DET-002': {
    priority: 'High',
    orgGuidance: 'Develop a detection rule lifecycle including development, testing, deployment, tuning, and retirement. Version control all detection content.',
    freeSolution: 'Git + CI/CD for detection-as-code, Sigma, YARA',
    vendorSolution: 'Splunk ESCU, Anvilogic, Panther, detection-as-code frameworks'
  },
  'DET-003': {
    priority: 'Moderate',
    orgGuidance: 'Implement detection testing using adversary emulation and atomic tests. Validate detection efficacy quarterly and after major infrastructure changes.',
    freeSolution: 'Atomic Red Team, MITRE Caldera, Stratus Red Team, Leonidas',
    vendorSolution: 'AttackIQ, SafeBreach, Cymulate, Picus Security'
  },
  'DET-004': {
    priority: 'High',
    orgGuidance: 'Map detection coverage to MITRE ATT&CK framework. Identify gaps in technique coverage and prioritize detection development for high-risk techniques.',
    freeSolution: 'DeTT&CT, ATT&CK Navigator, MITRE ATT&CK Workbench',
    vendorSolution: 'Tidal Cyber, AttackIQ, MITRE Engenuity evaluations'
  },
  'DET-005': {
    priority: 'Moderate',
    orgGuidance: 'Establish detection performance metrics including true positive rate, false positive rate, and mean time to detect. Review metrics monthly.',
    freeSolution: 'Custom SIEM dashboards, detection analytics scripts',
    vendorSolution: 'Splunk ES metrics, CardinalOps, SOC Prime'
  },
  // === RISK-BASED ALERTING ===
  'RBA-001': {
    priority: 'High',
    orgGuidance: 'Implement risk scoring for alerts based on asset criticality, user risk, and threat context. Prioritize SOC attention on highest-risk events.',
    freeSolution: 'Custom risk scoring in SIEM, Wazuh risk-based rules',
    vendorSolution: 'Splunk RBA, Microsoft Sentinel risk scores, Exabeam'
  },
  'RBA-002': {
    priority: 'High',
    orgGuidance: 'Integrate asset inventory with SIEM for automatic enrichment. Include asset criticality, owner, business unit, and data classification.',
    freeSolution: 'CMDB integration scripts, CSV lookups, NetBox integration',
    vendorSolution: 'Splunk Asset & Identity, ServiceNow integration, Axonius'
  },
  'RBA-003': {
    priority: 'Moderate',
    orgGuidance: 'Develop user risk profiles incorporating role, access level, security awareness scores, and historical incidents. Adjust alert severity based on user risk.',
    freeSolution: 'Custom user risk scoring, HR system integration',
    vendorSolution: 'Exabeam, Microsoft Sentinel UEBA, Securonix'
  },
  'RBA-004': {
    priority: 'Moderate',
    orgGuidance: 'Weight threat intelligence indicators by source reliability, age, and relevance to your environment. Deprioritize stale or low-confidence IOCs.',
    freeSolution: 'MISP confidence scoring, custom TI weighting',
    vendorSolution: 'ThreatConnect, Anomali, Recorded Future'
  },
  'RBA-005': {
    priority: 'Moderate',
    orgGuidance: 'Aggregate multiple low-confidence signals into high-confidence risk scores. Implement correlation rules that combine weak signals.',
    freeSolution: 'SIEM correlation rules, Sigma correlations',
    vendorSolution: 'Splunk RBA risk modifiers, Chronicle rules'
  },
  'RBA-006': {
    priority: 'Moderate',
    orgGuidance: 'Document and version control risk scoring methodology. Review and adjust weights quarterly based on detection efficacy.',
    freeSolution: 'Documented scoring in Git, spreadsheet models',
    vendorSolution: 'Splunk RBA dashboards, GRC platforms'
  },
  'RBA-007': {
    priority: 'Moderate',
    orgGuidance: 'Create risk-based alert thresholds that dynamically adjust based on threat landscape and organizational context.',
    freeSolution: 'Dynamic thresholds in SIEM, custom scripts',
    vendorSolution: 'Splunk adaptive thresholds, machine learning models'
  },
  // === DETECTION FIDELITY ===
  'FID-001': {
    priority: 'High',
    orgGuidance: 'Track false positive rates by detection rule. Target <10% false positive rate for production rules. Tune or disable rules exceeding threshold.',
    freeSolution: 'SIEM metrics dashboards, custom tracking spreadsheets',
    vendorSolution: 'Splunk ES metrics, CardinalOps, SOC Prime'
  },
  'FID-002': {
    priority: 'High',
    orgGuidance: 'Implement detection tuning process for reducing false positives while maintaining detection capability. Document tuning rationale.',
    freeSolution: 'Git-based rule management, tuning documentation',
    vendorSolution: 'Splunk Enterprise Security, Anvilogic'
  },
  'FID-003': {
    priority: 'Moderate',
    orgGuidance: 'Test detections for false negative rates using red team exercises and adversary emulation. Validate detections catch intended threats.',
    freeSolution: 'Atomic Red Team, MITRE Caldera, manual testing',
    vendorSolution: 'AttackIQ, SafeBreach, Cymulate'
  },
  'FID-004': {
    priority: 'Moderate',
    orgGuidance: 'Create exception processes for approved activities that would otherwise trigger alerts. Review exceptions quarterly.',
    freeSolution: 'Documented exception lists, SIEM suppression rules',
    vendorSolution: 'Splunk notable suppressions, SOAR exception workflows'
  },
  'FID-005': {
    priority: 'Moderate',
    orgGuidance: 'Regularly review and update detection rules based on threat landscape changes, infrastructure updates, and analyst feedback.',
    freeSolution: 'Quarterly detection review process, community rule updates',
    vendorSolution: 'SOC Prime updates, vendor rule packs'
  },
  // === AI & EMERGING THREATS ===
  'AI-001': {
    priority: 'High',
    orgGuidance: 'Implement detection capabilities for AI-generated phishing including linguistic analysis, sender reputation, and behavioral indicators. Train users on AI-generated content.',
    freeSolution: 'GPT detectors (limited), behavioral email analysis, user training',
    vendorSolution: 'Abnormal Security, Proofpoint AI, Microsoft Defender for Office 365'
  },
  'AI-002': {
    priority: 'High',
    orgGuidance: 'Establish verification procedures for voice/video requests involving financial transactions or sensitive actions. Implement callback verification to known numbers.',
    freeSolution: 'Policy-based controls, callback procedures, awareness training',
    vendorSolution: 'Pindrop, Reality Defender, deep learning detection tools'
  },
  'AI-003': {
    priority: 'Moderate',
    orgGuidance: 'Evaluate AI/ML tools for SOC automation including alert triage, threat hunting, and incident response. Pilot carefully with human oversight.',
    freeSolution: 'Open-source ML models, custom Python scripts, LLM integration',
    vendorSolution: 'Microsoft Security Copilot, Google Duet AI, vendor AI features'
  },
  'AI-004': {
    priority: 'Moderate',
    orgGuidance: 'Monitor for adversarial AI techniques including model poisoning, prompt injection, and AI-powered attacks. Stay current on emerging AI threats.',
    freeSolution: 'Threat intelligence feeds, security research monitoring',
    vendorSolution: 'HiddenLayer, Robust Intelligence, vendor threat feeds'
  },
  // === ALERT ROUTING ===
  'TRI-001': {
    priority: 'High',
    orgGuidance: 'Define alert severity levels with clear criteria and response SLAs. Document escalation procedures for each severity level.',
    freeSolution: 'Documented severity matrix, SIEM priority fields',
    vendorSolution: 'ITSM integration, PagerDuty, Opsgenie'
  },
  'TRI-002': {
    priority: 'High',
    orgGuidance: 'Implement alert routing rules directing alerts to appropriate teams based on asset type, business unit, and alert category.',
    freeSolution: 'SIEM routing rules, email/Slack integration',
    vendorSolution: 'SOAR platforms, ServiceNow, PagerDuty'
  },
  'TRI-003': {
    priority: 'Moderate',
    orgGuidance: 'Define and document triage criteria for initial alert assessment. Train analysts on consistent triage decision-making.',
    freeSolution: 'Documented triage playbooks, decision trees',
    vendorSolution: 'SOAR triage automation, TheHive, Cortex XSOAR'
  },
  'TRI-004': {
    priority: 'Moderate',
    orgGuidance: 'Implement alert aggregation and deduplication to reduce analyst fatigue. Group related alerts into incidents.',
    freeSolution: 'SIEM correlation rules, custom aggregation scripts',
    vendorSolution: 'Splunk ES notable aggregation, Microsoft Sentinel incidents'
  },
  'TRI-005': {
    priority: 'High',
    orgGuidance: 'Establish SLAs for alert response based on severity. Track SLA compliance and address systemic delays.',
    freeSolution: 'SLA tracking dashboards, alerting on SLA breach',
    vendorSolution: 'ServiceNow SLA management, SOAR SLA tracking'
  },
  'TRI-006': {
    priority: 'Moderate',
    orgGuidance: 'Implement after-hours escalation procedures and on-call rotations. Ensure 24x7 coverage for critical alerts.',
    freeSolution: 'On-call schedules, phone trees, Slack/Teams alerts',
    vendorSolution: 'PagerDuty, Opsgenie, VictorOps, xMatters'
  },
  // === SOAR ===
  'SOAR-001': {
    priority: 'High',
    orgGuidance: 'Deploy a SOAR platform to automate repetitive investigation tasks. Start with high-volume, low-complexity alert types.',
    freeSolution: 'Shuffle SOAR, TheHive + Cortex, n8n, Tines Community',
    vendorSolution: 'Palo Alto Cortex XSOAR, Splunk SOAR, Microsoft Sentinel SOAR, Swimlane'
  },
  'SOAR-002': {
    priority: 'High',
    orgGuidance: 'Develop automated enrichment playbooks that gather context from threat intelligence, asset inventory, and identity systems.',
    freeSolution: 'Cortex analyzers, custom API integrations, Shuffle workflows',
    vendorSolution: 'XSOAR integrations, Splunk SOAR apps, Tines'
  },
  'SOAR-003': {
    priority: 'Moderate',
    orgGuidance: 'Implement automated response actions for high-confidence threats. Start with containment actions and expand based on success.',
    freeSolution: 'TheHive responders, custom scripts, Shuffle automation',
    vendorSolution: 'XSOAR playbooks, Splunk SOAR, Swimlane'
  },
  'SOAR-004': {
    priority: 'Moderate',
    orgGuidance: 'Integrate SOAR with ticketing systems for automatic case creation and updates. Ensure bidirectional synchronization.',
    freeSolution: 'TheHive + JIRA/ServiceNow integration, custom scripts',
    vendorSolution: 'Native ITSM integrations, iPaaS connectors'
  },
  'SOAR-005': {
    priority: 'Moderate',
    orgGuidance: 'Track SOAR metrics including automation rate, playbook success rate, and time savings. Optimize playbooks based on data.',
    freeSolution: 'Custom metrics dashboards, playbook logging',
    vendorSolution: 'SOAR analytics dashboards, vendor reporting'
  },
  // === SOPs ===
  'SOP-001': {
    priority: 'High',
    orgGuidance: 'Develop standardized investigation playbooks for each major alert type. Include investigation steps, escalation criteria, and closure requirements.',
    freeSolution: 'Wiki/Confluence documentation, Git-based playbooks',
    vendorSolution: 'SOAR playbooks, ServiceNow Knowledge Base'
  },
  'SOP-002': {
    priority: 'High',
    orgGuidance: 'Create runbooks for common response scenarios including malware infection, account compromise, and data exfiltration.',
    freeSolution: 'Documented runbooks, decision trees, checklists',
    vendorSolution: 'SOAR workflows, incident response platforms'
  },
  'SOP-003': {
    priority: 'Moderate',
    orgGuidance: 'Implement a playbook review and update process. Review playbooks after major incidents and quarterly at minimum.',
    freeSolution: 'Version-controlled documentation, review checklists',
    vendorSolution: 'Document management systems, SOAR versioning'
  },
  'SOP-004': {
    priority: 'Moderate',
    orgGuidance: 'Train analysts on playbook execution and ensure consistent application. Measure playbook adherence during quality reviews.',
    freeSolution: 'Training documentation, shadowing programs',
    vendorSolution: 'SOAR guided workflows, training platforms'
  },
  'SOP-005': {
    priority: 'Moderate',
    orgGuidance: 'Document escalation criteria and procedures for each playbook. Include contact information and decision authorities.',
    freeSolution: 'Escalation matrices, contact lists, decision trees',
    vendorSolution: 'ITSM escalation workflows, on-call management'
  },
  'SOP-006': {
    priority: 'Moderate',
    orgGuidance: 'Maintain playbooks for external coordination including law enforcement engagement, customer notification, and vendor escalation.',
    freeSolution: 'Documented procedures, contact directories',
    vendorSolution: 'Incident response retainers, legal counsel'
  },
  // === INCIDENT MANAGEMENT ===
  'INC-001': {
    priority: 'High',
    orgGuidance: 'Deploy an incident management platform for tracking all security incidents from detection through closure. Ensure audit trail.',
    freeSolution: 'TheHive, RTIR, osTicket, custom ticketing',
    vendorSolution: 'ServiceNow SecOps, Jira, Splunk SOAR, PagerDuty'
  },
  'INC-002': {
    priority: 'High',
    orgGuidance: 'Define incident classification taxonomy with clear criteria. Align with organizational risk framework and regulatory requirements.',
    freeSolution: 'NIST incident categories, custom taxonomy documentation',
    vendorSolution: 'ITSM incident types, GRC platform integration'
  },
  'INC-003': {
    priority: 'High',
    orgGuidance: 'Establish incident commander role and responsibilities. Train personnel and rotate the role to build organizational capability.',
    freeSolution: 'ICS training, documented role descriptions',
    vendorSolution: 'Incident response training, tabletop exercises'
  },
  'INC-004': {
    priority: 'Moderate',
    orgGuidance: 'Implement secure communication channels for incident coordination. Include out-of-band options if primary systems are compromised.',
    freeSolution: 'Signal, Mattermost, separate email domain',
    vendorSolution: 'Slack Enterprise Grid, Microsoft Teams (secured), dedicated IR tools'
  },
  'INC-005': {
    priority: 'Moderate',
    orgGuidance: 'Define stakeholder communication procedures including executive updates, legal notification, and customer communication.',
    freeSolution: 'Communication templates, stakeholder matrices',
    vendorSolution: 'Crisis communication platforms, PR support'
  },
  'INC-006': {
    priority: 'High',
    orgGuidance: 'Conduct regular incident response exercises including tabletops and functional exercises. Test against realistic scenarios.',
    freeSolution: 'Tabletop exercise frameworks, scenario development',
    vendorSolution: 'IR retainer services, red team exercises'
  },
  'INC-007': {
    priority: 'Moderate',
    orgGuidance: 'Maintain incident response team contact information and availability. Ensure 24x7 coverage for critical incidents.',
    freeSolution: 'Contact lists, on-call schedules, phone trees',
    vendorSolution: 'PagerDuty, Opsgenie, on-call management'
  },
  'INC-008': {
    priority: 'Moderate',
    orgGuidance: 'Document incident severity levels with escalation criteria and response timelines. Align with business impact assessments.',
    freeSolution: 'Severity matrix documentation, response SLAs',
    vendorSolution: 'ITSM severity configuration, SLA management'
  },
  'INC-009': {
    priority: 'Moderate',
    orgGuidance: 'Establish relationships with external parties including law enforcement, ISACs, and incident response vendors before incidents occur.',
    freeSolution: 'ISAC membership, FBI/CISA relationships',
    vendorSolution: 'IR retainers, managed detection and response'
  },
  'INC-010': {
    priority: 'Moderate',
    orgGuidance: 'Maintain current cyber insurance policy with appropriate coverage. Understand policy requirements and notification obligations.',
    freeSolution: 'Policy review, coverage assessment',
    vendorSolution: 'Cyber insurance brokers, legal review'
  },
  // === CONTAINMENT ===
  'CON-001': {
    priority: 'High',
    orgGuidance: 'Develop containment procedures for various threat types including network isolation, account suspension, and system quarantine.',
    freeSolution: 'Documented procedures, scripted containment actions',
    vendorSolution: 'EDR isolation, NAC integration, SOAR containment playbooks'
  },
  'CON-002': {
    priority: 'High',
    orgGuidance: 'Pre-authorize containment actions for defined scenarios to enable rapid response. Document approval requirements for each action.',
    freeSolution: 'Pre-authorization matrix, documented procedures',
    vendorSolution: 'SOAR automated containment, approval workflows'
  },
  'CON-003': {
    priority: 'Moderate',
    orgGuidance: 'Implement network segmentation capabilities for rapid isolation. Test isolation procedures quarterly.',
    freeSolution: 'Firewall rules, VLAN isolation, iptables scripts',
    vendorSolution: 'NAC solutions, microsegmentation, SDN'
  },
  'CON-004': {
    priority: 'Moderate',
    orgGuidance: 'Document containment decision criteria balancing security impact with business disruption. Include rollback procedures.',
    freeSolution: 'Decision trees, impact assessment templates',
    vendorSolution: 'SOAR decision workflows, approval chains'
  },
  // === CTI ===
  'CTI-001': {
    priority: 'High',
    orgGuidance: 'Establish a threat intelligence program collecting, analyzing, and distributing actionable intelligence. Align with organizational threat profile.',
    freeSolution: 'MISP, OpenCTI, IntelMQ, free TI feeds',
    vendorSolution: 'Recorded Future, Mandiant, ThreatConnect, Anomali'
  },
  'CTI-002': {
    priority: 'High',
    orgGuidance: 'Integrate threat intelligence with detection systems for automated IOC matching. Implement confidence scoring and aging.',
    freeSolution: 'MISP + SIEM integration, STIX/TAXII feeds',
    vendorSolution: 'TIP integrations, vendor threat feeds'
  },
  'CTI-003': {
    priority: 'Moderate',
    orgGuidance: 'Produce tactical intelligence reports for SOC analysts including IOCs, TTPs, and recommended detections.',
    freeSolution: 'Intelligence report templates, wiki documentation',
    vendorSolution: 'TIP reporting, intelligence platforms'
  },
  'CTI-004': {
    priority: 'Moderate',
    orgGuidance: 'Develop strategic intelligence assessments for leadership including threat landscape trends and organizational risk context.',
    freeSolution: 'Quarterly threat briefings, executive summaries',
    vendorSolution: 'Intelligence services, CISO advisory'
  },
  'CTI-005': {
    priority: 'High',
    orgGuidance: 'Deploy a Threat Intelligence Platform to aggregate, normalize, and operationalize intelligence from multiple sources.',
    freeSolution: 'MISP, OpenCTI, Yeti, CRITs',
    vendorSolution: 'ThreatConnect, Anomali ThreatStream, Recorded Future, MISP Enterprise'
  },
  'CTI-006': {
    priority: 'High',
    orgGuidance: 'Implement proactive blocking of known malicious indicators across firewalls, proxies, and endpoint tools. Automate feed updates.',
    freeSolution: 'Threat feed automation, firewall block lists, DNS sinkholes',
    vendorSolution: 'Palo Alto AutoFocus, Cisco Talos, vendor threat prevention'
  },
  'CTI-007': {
    priority: 'Moderate',
    orgGuidance: 'Conduct threat modeling exercises to identify likely adversaries, attack vectors, and defensive gaps. Update annually and after major changes.',
    freeSolution: 'STRIDE, PASTA, ATT&CK-based modeling, threat trees',
    vendorSolution: 'Tidal Cyber, ThreatModeler, professional assessments'
  },
  // === FORENSICS ===
  'FOR-001': {
    priority: 'High',
    orgGuidance: 'Establish forensic investigation capabilities including trained personnel, tools, and procedures. Maintain chain of custody.',
    freeSolution: 'Autopsy, Volatility, SIFT Workstation, Velociraptor',
    vendorSolution: 'EnCase, FTK, Magnet AXIOM, Exterro'
  },
  'FOR-002': {
    priority: 'Moderate',
    orgGuidance: 'Deploy forensic collection tools capable of acquiring memory, disk, and network artifacts. Pre-position tools on critical systems.',
    freeSolution: 'KAPE, Velociraptor, LiME, dc3dd',
    vendorSolution: 'CrowdStrike Falcon Forensics, Carbon Black, Tanium'
  },
  'FOR-003': {
    priority: 'Moderate',
    orgGuidance: 'Develop forensic analysis procedures for common scenarios including malware analysis, intrusion investigation, and insider threat.',
    freeSolution: 'Documented procedures, analysis checklists',
    vendorSolution: 'Forensic services, training programs'
  },
  'FOR-004': {
    priority: 'Moderate',
    orgGuidance: 'Maintain forensic readiness including evidence preservation policies, legal hold procedures, and expert witness relationships.',
    freeSolution: 'Policies, procedures, evidence handling training',
    vendorSolution: 'Legal counsel, forensic retainers, e-discovery'
  },
  // === RECOVERY ===
  'REC-001': {
    priority: 'High',
    orgGuidance: 'Develop recovery procedures for various incident types including ransomware, data breach, and system compromise. Test annually.',
    freeSolution: 'Recovery playbooks, backup verification',
    vendorSolution: 'DR services, backup solutions, IR retainers'
  },
  'REC-002': {
    priority: 'High',
    orgGuidance: 'Implement and test backup and recovery capabilities. Ensure backups are isolated from production and protected from ransomware.',
    freeSolution: 'rsync, Bacula, Restic, air-gapped backups',
    vendorSolution: 'Veeam, Cohesity, Rubrik, Commvault'
  },
  'REC-003': {
    priority: 'Moderate',
    orgGuidance: 'Document system rebuild procedures including gold images, configuration baselines, and application deployment.',
    freeSolution: 'Ansible, Terraform, documented procedures',
    vendorSolution: 'Configuration management, image deployment'
  },
  'REC-004': {
    priority: 'Moderate',
    orgGuidance: 'Define recovery time objectives (RTO) and recovery point objectives (RPO) for critical systems. Align DR capabilities.',
    freeSolution: 'BIA documentation, DR planning templates',
    vendorSolution: 'DR services, cloud DR, business continuity'
  },
  // === PIR ===
  'PIR-001': {
    priority: 'High',
    orgGuidance: 'Conduct post-incident reviews for all significant incidents. Identify root causes, lessons learned, and improvement opportunities.',
    freeSolution: 'PIR templates, blameless postmortem process',
    vendorSolution: 'Incident management platforms, PIR facilitation'
  },
  'PIR-002': {
    priority: 'Moderate',
    orgGuidance: 'Track remediation actions from PIRs to completion. Assign owners and deadlines for each improvement item.',
    freeSolution: 'Action item tracking, project management tools',
    vendorSolution: 'GRC platforms, ITSM tracking'
  },
  'PIR-003': {
    priority: 'Moderate',
    orgGuidance: 'Share lessons learned across the organization and with industry peers through ISACs and trusted communities.',
    freeSolution: 'Internal briefings, ISAC participation',
    vendorSolution: 'Intelligence sharing platforms, industry groups'
  },
  'PIR-004': {
    priority: 'Moderate',
    orgGuidance: 'Update detection rules, playbooks, and procedures based on PIR findings. Track detection improvements from incidents.',
    freeSolution: 'Detection improvement tracking, playbook updates',
    vendorSolution: 'Detection engineering programs, SOAR updates'
  },
  // === METRICS ===
  'MET-001': {
    priority: 'High',
    orgGuidance: 'Define and track key SOC metrics including MTTD, MTTR, alert volume, and incident trends. Report to leadership monthly.',
    freeSolution: 'SIEM dashboards, spreadsheet tracking, Grafana',
    vendorSolution: 'SOC analytics platforms, executive dashboards'
  },
  'MET-002': {
    priority: 'Moderate',
    orgGuidance: 'Measure detection coverage using MITRE ATT&CK framework. Track coverage improvements over time.',
    freeSolution: 'DeTT&CT, ATT&CK Navigator, custom tracking',
    vendorSolution: 'AttackIQ, detection coverage platforms'
  },
  'MET-003': {
    priority: 'Moderate',
    orgGuidance: 'Track analyst productivity and workload distribution. Identify bottlenecks and optimize staffing.',
    freeSolution: 'Ticket metrics, time tracking, custom dashboards',
    vendorSolution: 'SOAR analytics, workforce management'
  },
  'MET-004': {
    priority: 'Moderate',
    orgGuidance: 'Benchmark SOC performance against industry peers and maturity frameworks. Identify improvement priorities.',
    freeSolution: 'SANS SOC Survey, industry reports, self-assessment',
    vendorSolution: 'SOC maturity assessments, consulting services'
  },
  'MET-005': {
    priority: 'High',
    orgGuidance: 'Implement granular time-based metrics including MTTD, MTTI (investigate), and MTTC (contain) by alert type and severity.',
    freeSolution: 'Custom SIEM calculations, ticket timestamp analysis',
    vendorSolution: 'SOAR metrics, SOC analytics platforms'
  },
  'MET-006': {
    priority: 'Moderate',
    orgGuidance: 'Track per-rule detection quality metrics including true positive rate, false positive rate, and alert-to-incident ratio.',
    freeSolution: 'Detection analytics dashboards, rule performance tracking',
    vendorSolution: 'CardinalOps, SOC Prime, detection engineering platforms'
  },
  'MET-007': {
    priority: 'High',
    orgGuidance: 'Collect metrics demonstrating SOC value and resource needs for staffing justification. Include cost avoidance and risk reduction.',
    freeSolution: 'ROI calculations, incident cost tracking, workload analysis',
    vendorSolution: 'GRC platforms, executive reporting tools'
  },
  // === THREAT HUNTING ===
  'HUNT-001': {
    priority: 'High',
    orgGuidance: 'Establish a dedicated threat hunting program with trained personnel, documented methodology, and regular hunting cadence.',
    freeSolution: 'TaHiTI framework, PEAK methodology, hunting playbooks',
    vendorSolution: 'Threat hunting services, MDR with hunting'
  },
  'HUNT-002': {
    priority: 'Moderate',
    orgGuidance: 'Develop hypothesis-driven hunts based on threat intelligence, organizational risk, and coverage gaps. Prioritize high-impact techniques.',
    freeSolution: 'Hunt hypothesis templates, ATT&CK-based prioritization',
    vendorSolution: 'Threat hunting platforms, intelligence services'
  },
  'HUNT-003': {
    priority: 'Moderate',
    orgGuidance: 'Document hunt findings including methodology, data sources, queries, and outcomes. Maintain a hunt repository.',
    freeSolution: 'Wiki documentation, Git-based hunt tracking',
    vendorSolution: 'Hunting platforms, knowledge management'
  },
  'HUNT-004': {
    priority: 'High',
    orgGuidance: 'Convert successful hunts into automated detections. Track the hunt-to-detection pipeline and measure detection creation.',
    freeSolution: 'Sigma rule creation, detection engineering process',
    vendorSolution: 'Detection-as-code platforms, SIEM rule development'
  },
  'HUNT-005': {
    priority: 'Moderate',
    orgGuidance: 'Establish a regular hunting cadence (weekly/monthly) and track completion. Adjust frequency based on threat landscape.',
    freeSolution: 'Hunt scheduling, completion tracking',
    vendorSolution: 'Hunting program management, MDR services'
  },
  'HUNT-006': {
    priority: 'Moderate',
    orgGuidance: 'Develop threat profiles for adversaries targeting your industry. Use profiles to prioritize hunts and detection development.',
    freeSolution: 'MITRE ATT&CK groups, ISAC intelligence, open-source research',
    vendorSolution: 'Threat intelligence services, adversary profiles'
  },
  // === PROACTIVE SECURITY ===
  'VUL-001': {
    priority: 'High',
    orgGuidance: 'Implement continuous vulnerability scanning across all assets. Prioritize remediation based on exploitability and asset criticality.',
    freeSolution: 'OpenVAS, Nuclei, Nessus Essentials, Trivy',
    vendorSolution: 'Tenable, Qualys, Rapid7 InsightVM, CrowdStrike Spotlight'
  },
  'VUL-002': {
    priority: 'High',
    orgGuidance: 'Define vulnerability remediation SLAs based on severity and asset criticality. Track compliance and escalate overdue items.',
    freeSolution: 'Tracking spreadsheets, ticketing integration',
    vendorSolution: 'Vulnerability management platforms, risk-based prioritization'
  },
  'VUL-003': {
    priority: 'Moderate',
    orgGuidance: 'Implement exception management for vulnerabilities that cannot be remediated. Document risk acceptance and compensating controls.',
    freeSolution: 'Exception tracking, risk register',
    vendorSolution: 'GRC platforms, vulnerability management'
  },
  'VUL-004': {
    priority: 'Moderate',
    orgGuidance: 'Integrate vulnerability data with SIEM for detection enrichment. Alert on exploitation attempts against known vulnerabilities.',
    freeSolution: 'Vulnerability feed integration, SIEM enrichment',
    vendorSolution: 'Integrated security platforms, XDR'
  },
  'ASM-001': {
    priority: 'High',
    orgGuidance: 'Implement external attack surface management to discover internet-facing assets and exposures. Scan continuously.',
    freeSolution: 'Shodan, Censys, Amass, subfinder',
    vendorSolution: 'Palo Alto Cortex Xpanse, Mandiant ASM, CyCognito, Censys ASM'
  },
  'ASM-002': {
    priority: 'Moderate',
    orgGuidance: 'Integrate ASM findings with vulnerability management and SOC workflows. Alert on new exposures within 24 hours.',
    freeSolution: 'Custom integrations, alerting scripts',
    vendorSolution: 'Platform integrations, unified security'
  },
  'ASM-003': {
    priority: 'Moderate',
    orgGuidance: 'Monitor for brand impersonation, typosquatting, and credential leaks. Take down malicious domains promptly.',
    freeSolution: 'dnstwist, PhishTank monitoring, Have I Been Pwned',
    vendorSolution: 'Digital risk protection, brand protection services'
  },
  'PEN-001': {
    priority: 'High',
    orgGuidance: 'Conduct annual penetration testing of critical systems and applications. Remediate critical findings within 30 days.',
    freeSolution: 'Internal red team, bug bounty programs',
    vendorSolution: 'Penetration testing services, red team engagements'
  },
  'PEN-002': {
    priority: 'Moderate',
    orgGuidance: 'Use penetration test findings to validate and improve detection capabilities. Track detection of test activities.',
    freeSolution: 'Purple team exercises, detection validation',
    vendorSolution: 'Red/purple team services, breach simulation'
  },
  'PUR-001': {
    priority: 'Moderate',
    orgGuidance: 'Conduct purple team exercises combining offensive and defensive teams. Use findings to improve detections and response.',
    freeSolution: 'Internal purple team, Atomic Red Team',
    vendorSolution: 'Purple team services, adversary simulation'
  },
  'PUR-002': {
    priority: 'Moderate',
    orgGuidance: 'Document purple team findings and track detection improvements. Measure detection coverage changes over time.',
    freeSolution: 'Exercise documentation, ATT&CK Navigator',
    vendorSolution: 'Breach simulation platforms, reporting'
  },
  // === 3RD PARTY RISK ===
  'TPR-001': {
    priority: 'High',
    orgGuidance: 'Establish third-party risk management program assessing vendor security posture before and during engagements.',
    freeSolution: 'Security questionnaires, contract reviews',
    vendorSolution: 'SecurityScorecard, BitSight, RiskRecon, OneTrust'
  },
  'TPR-002': {
    priority: 'Moderate',
    orgGuidance: 'Monitor critical vendors for security incidents and changes in risk posture. Include notification requirements in contracts.',
    freeSolution: 'News monitoring, vendor communication',
    vendorSolution: 'Continuous monitoring services, vendor risk platforms'
  },
  'TPR-003': {
    priority: 'Moderate',
    orgGuidance: 'Integrate third-party risk data with SOC workflows. Include vendor context in incident investigations.',
    freeSolution: 'Vendor asset tagging, documentation',
    vendorSolution: 'TPRM platform integration, CMDB enrichment'
  },
  'TPR-004': {
    priority: 'Moderate',
    orgGuidance: 'Establish incident response procedures for vendor-related incidents. Define notification and coordination requirements.',
    freeSolution: 'Vendor IR playbooks, contact procedures',
    vendorSolution: 'Vendor management platforms, IR coordination'
  },
  'TPR-005': {
    priority: 'Moderate',
    orgGuidance: 'Conduct regular vendor security assessments based on criticality. Require evidence of security controls.',
    freeSolution: 'Assessment questionnaires, SOC 2 review',
    vendorSolution: 'TPRM platforms, assessment services'
  },
};

// Benchmark data - synthetic assessments across industries/sizes
const benchmarkData = {
  financial: {
    smb: { avg: 42, p25: 35, p50: 42, p75: 52 },
    midmarket: { avg: 55, p25: 48, p50: 55, p75: 65 },
    enterprise: { avg: 68, p25: 60, p50: 68, p75: 78 },
    large: { avg: 75, p25: 68, p50: 75, p75: 85 },
  },
  healthcare: {
    smb: { avg: 38, p25: 30, p50: 38, p75: 48 },
    midmarket: { avg: 50, p25: 42, p50: 50, p75: 60 },
    enterprise: { avg: 62, p25: 55, p50: 62, p75: 72 },
    large: { avg: 70, p25: 62, p50: 70, p75: 80 },
  },
  technology: {
    smb: { avg: 48, p25: 40, p50: 48, p75: 58 },
    midmarket: { avg: 60, p25: 52, p50: 60, p75: 70 },
    enterprise: { avg: 72, p25: 65, p50: 72, p75: 82 },
    large: { avg: 80, p25: 72, p50: 80, p75: 88 },
  },
  manufacturing: {
    smb: { avg: 32, p25: 25, p50: 32, p75: 42 },
    midmarket: { avg: 45, p25: 38, p50: 45, p75: 55 },
    enterprise: { avg: 58, p25: 50, p50: 58, p75: 68 },
    large: { avg: 65, p25: 58, p50: 65, p75: 75 },
  },
  government: {
    smb: { avg: 45, p25: 38, p50: 45, p75: 55 },
    midmarket: { avg: 55, p25: 48, p50: 55, p75: 65 },
    enterprise: { avg: 65, p25: 58, p50: 65, p75: 75 },
    large: { avg: 72, p25: 65, p50: 72, p75: 82 },
  },
  other: {
    smb: { avg: 35, p25: 28, p50: 35, p75: 45 },
    midmarket: { avg: 48, p25: 40, p50: 48, p75: 58 },
    enterprise: { avg: 58, p25: 50, p50: 58, p75: 68 },
    large: { avg: 65, p25: 58, p50: 65, p75: 75 },
  },
};

// Get benchmark comparison
const getBenchmarkComparison = (score, industry, companySize) => {
  const industryData = benchmarkData[industry] || benchmarkData.other;
  const sizeData = industryData[companySize] || industryData.midmarket;
  
  let percentile;
  if (score <= sizeData.p25) {
    percentile = Math.round((score / sizeData.p25) * 25);
  } else if (score <= sizeData.p50) {
    percentile = 25 + Math.round(((score - sizeData.p25) / (sizeData.p50 - sizeData.p25)) * 25);
  } else if (score <= sizeData.p75) {
    percentile = 50 + Math.round(((score - sizeData.p50) / (sizeData.p75 - sizeData.p50)) * 25);
  } else {
    percentile = 75 + Math.round(((score - sizeData.p75) / (100 - sizeData.p75)) * 25);
  }
  percentile = Math.min(99, Math.max(1, percentile));
  
  const diff = score - sizeData.avg;
  let comparison;
  if (diff > 15) comparison = 'significantly above';
  else if (diff > 5) comparison = 'above';
  else if (diff > -5) comparison = 'on par with';
  else if (diff > -15) comparison = 'below';
  else comparison = 'significantly below';
  
  return {
    percentile,
    comparison,
    peerAverage: sizeData.avg,
    diff: Math.round(diff),
  };
};

// PDF Generation
const generatePDF = (clientInfo, answers, assessmentSections, calculateSectionScore, calculateOverallScore, getSectionCompletion) => {
  const doc = new jsPDF();
  const pageWidth = doc.internal.pageSize.getWidth();
  const margin = 20;
  let y = 20;

  // Helper to add new page if needed
  const checkPageBreak = (neededSpace = 40) => {
    if (y + neededSpace > 270) {
      doc.addPage();
      y = 20;
    }
  };

  // Colors
  const purple = [139, 92, 246];
  const gray = [107, 114, 128];
  const dark = [30, 30, 40];

  // Header
  doc.setFillColor(...purple);
  doc.rect(0, 0, pageWidth, 35, 'F');
  doc.setTextColor(255, 255, 255);
  doc.setFontSize(20);
  doc.setFont('helvetica', 'bold');
  doc.text('GRAY CORP', margin, 18);
  doc.setFontSize(10);
  doc.setFont('helvetica', 'normal');
  doc.text('SOC Maturity Assessment Report', margin, 28);
  
  y = 50;

  // Client Info
  doc.setTextColor(...dark);
  doc.setFontSize(12);
  doc.setFont('helvetica', 'bold');
  doc.text('Assessment Details', margin, y);
  y += 8;
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(10);
  doc.setTextColor(...gray);
  doc.text(`Organization: ${clientInfo.organization || 'Not specified'}`, margin, y);
  y += 6;
  doc.text(`Prepared for: ${clientInfo.name || 'Not specified'}`, margin, y);
  y += 6;
  doc.text(`Date: ${new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}`, margin, y);
  y += 6;
  if (clientInfo.industry) doc.text(`Industry: ${clientInfo.industry}`, margin, y);
  y += 15;

  // Overall Score
  const overallScore = calculateOverallScore();
  const maturity = getMaturityLevel(overallScore);
  
  doc.setFillColor(248, 246, 255);
  doc.roundedRect(margin, y, pageWidth - 2 * margin, 35, 3, 3, 'F');
  
  doc.setTextColor(...purple);
  doc.setFontSize(28);
  doc.setFont('helvetica', 'bold');
  doc.text(Math.round(overallScore).toString(), margin + 10, y + 22);
  doc.setFontSize(12);
  doc.text('/ 100', margin + 35, y + 22);
  
  doc.setTextColor(...dark);
  doc.setFontSize(14);
  doc.text(`${maturity.level} Maturity`, margin + 70, y + 15);
  doc.setFontSize(9);
  doc.setTextColor(...gray);
  doc.text(maturity.description, margin + 70, y + 25);
  
  y += 50;

  // Domain Breakdown Table
  doc.setTextColor(...dark);
  doc.setFontSize(12);
  doc.setFont('helvetica', 'bold');
  doc.text('Domain Scores', margin, y);
  y += 5;

  const domainData = assessmentSections.map(s => {
    const score = calculateSectionScore(s.id);
    const mat = getMaturityLevel(score);
    const comp = getSectionCompletion(s.id);
    return [
      s.name,
      s.nistFunction,
      `${Math.round(s.weight * 100)}%`,
      comp > 0 ? Math.round(score).toString() : '—',
      comp > 0 ? mat.level : 'N/A'
    ];
  });

  autoTable(doc, {
    startY: y,
    head: [['Domain', 'NIST Function', 'Weight', 'Score', 'Maturity']],
    body: domainData,
    theme: 'striped',
    headStyles: { fillColor: purple, fontSize: 9 },
    bodyStyles: { fontSize: 9 },
    columnStyles: {
      0: { cellWidth: 50 },
      3: { halign: 'center' },
      4: { halign: 'center' }
    },
    margin: { left: margin, right: margin }
  });

  y = doc.lastAutoTable.finalY + 15;

  // Professional Findings & Recommendations Section
  checkPageBreak(30);
  doc.addPage();
  y = 20;
  
  // Section header
  doc.setFillColor(...purple);
  doc.rect(0, 0, pageWidth, 25, 'F');
  doc.setTextColor(255, 255, 255);
  doc.setFontSize(16);
  doc.setFont('helvetica', 'bold');
  doc.text('Findings & Recommendations', margin, 16);
  y = 35;

  // Collect all low-score questions with recommendations
  const allFindings = [];
  assessmentSections.forEach(section => {
    section.subsections.forEach(sub => {
      sub.questions.forEach(q => {
        if (answers[q.id] !== undefined && answers[q.id] < 2) {
          const cisMapping = questionCISMapping[q.id] || [];
          const rec = questionRecommendations[q.id];
          allFindings.push({
            id: q.id,
            text: q.text,
            currentState: q.options[answers[q.id]],
            score: answers[q.id] + 1,
            section: section.name,
            subsection: sub.name,
            cisControls: cisMapping,
            recommendation: rec,
            priority: rec?.priority || 'Moderate'
          });
        }
      });
    });
  });

  // Sort by priority (High first) then by section
  allFindings.sort((a, b) => {
    if (a.priority === 'High' && b.priority !== 'High') return -1;
    if (a.priority !== 'High' && b.priority === 'High') return 1;
    return a.section.localeCompare(b.section);
  });

  // Group findings by priority
  const highPriority = allFindings.filter(f => f.priority === 'High');
  const moderatePriority = allFindings.filter(f => f.priority === 'Moderate');

  // Helper to render a finding
  const renderFinding = (finding, index) => {
    const neededSpace = 85; // Estimate space needed per finding
    checkPageBreak(neededSpace);

    // Priority badge and title
    const priorityColor = finding.priority === 'High' ? [220, 38, 38] : [234, 179, 8];
    doc.setFillColor(...priorityColor);
    doc.roundedRect(margin, y, 45, 6, 1, 1, 'F');
    doc.setTextColor(255, 255, 255);
    doc.setFontSize(7);
    doc.setFont('helvetica', 'bold');
    doc.text(`${finding.priority.toUpperCase()} PRIORITY`, margin + 2, y + 4.5);
    
    // Finding ID and title
    doc.setTextColor(...purple);
    doc.setFontSize(10);
    doc.setFont('helvetica', 'bold');
    doc.text(`[${finding.id}] ${finding.subsection}`, margin + 50, y + 4.5);
    y += 12;

    // CIS Control mapping
    if (finding.cisControls && finding.cisControls.length > 0) {
      doc.setFillColor(240, 240, 255);
      doc.roundedRect(margin, y - 3, pageWidth - 2 * margin, 8, 1, 1, 'F');
      doc.setTextColor(100, 100, 140);
      doc.setFontSize(8);
      doc.setFont('helvetica', 'bold');
      const cisText = finding.cisControls.map(c => `CIS ${c}: ${cisControls[c]?.name || ''}`).join(' | ');
      doc.text(cisText, margin + 3, y + 2);
      y += 10;
    }

    // Finding description (current state)
    doc.setTextColor(...dark);
    doc.setFontSize(9);
    doc.setFont('helvetica', 'bold');
    doc.text('Finding:', margin, y);
    doc.setFont('helvetica', 'normal');
    y += 5;
    const findingLines = doc.splitTextToSize(`Current State: ${finding.currentState}. ${finding.text}`, pageWidth - 2 * margin - 5);
    findingLines.forEach(line => {
      checkPageBreak(5);
      doc.text(line, margin + 3, y);
      y += 4;
    });
    y += 3;

    // Organizational Recommendation
    if (finding.recommendation?.orgGuidance) {
      checkPageBreak(20);
      doc.setFillColor(248, 250, 252);
      const recLines = doc.splitTextToSize(finding.recommendation.orgGuidance, pageWidth - 2 * margin - 10);
      const recHeight = recLines.length * 4 + 10;
      doc.roundedRect(margin, y - 2, pageWidth - 2 * margin, recHeight, 2, 2, 'F');
      
      doc.setTextColor(...purple);
      doc.setFontSize(8);
      doc.setFont('helvetica', 'bold');
      doc.text('RECOMMENDATION', margin + 3, y + 3);
      y += 7;
      
      doc.setTextColor(...dark);
      doc.setFont('helvetica', 'normal');
      recLines.forEach(line => {
        checkPageBreak(5);
        doc.text(line, margin + 5, y);
        y += 4;
      });
      y += 5;
    }

    // Solutions table
    if (finding.recommendation?.freeSolution || finding.recommendation?.vendorSolution) {
      checkPageBreak(20);
      
      const solutionData = [];
      if (finding.recommendation?.freeSolution) {
        solutionData.push(['Free/Open Source', finding.recommendation.freeSolution]);
      }
      if (finding.recommendation?.vendorSolution) {
        solutionData.push(['Commercial Vendor', finding.recommendation.vendorSolution]);
      }

      autoTable(doc, {
        startY: y,
        head: [['Solution Type', 'Options']],
        body: solutionData,
        theme: 'grid',
        headStyles: { fillColor: [100, 100, 140], fontSize: 7, cellPadding: 2 },
        bodyStyles: { fontSize: 7, cellPadding: 2 },
        columnStyles: {
          0: { cellWidth: 35, fontStyle: 'bold' },
          1: { cellWidth: pageWidth - 2 * margin - 35 }
        },
        margin: { left: margin, right: margin },
        tableWidth: pageWidth - 2 * margin
      });
      y = doc.lastAutoTable.finalY + 8;
    }

    // Separator line
    doc.setDrawColor(220, 220, 230);
    doc.line(margin, y, pageWidth - margin, y);
    y += 8;
  };

  // Render High Priority findings
  if (highPriority.length > 0) {
    doc.setTextColor(...dark);
    doc.setFontSize(12);
    doc.setFont('helvetica', 'bold');
    doc.text(`High Priority Findings (${highPriority.length})`, margin, y);
    y += 10;
    
    highPriority.forEach((finding, idx) => renderFinding(finding, idx));
  }

  // Render Moderate Priority findings
  if (moderatePriority.length > 0) {
    checkPageBreak(30);
    doc.setTextColor(...dark);
    doc.setFontSize(12);
    doc.setFont('helvetica', 'bold');
    doc.text(`Moderate Priority Findings (${moderatePriority.length})`, margin, y);
    y += 10;
    
    moderatePriority.forEach((finding, idx) => renderFinding(finding, idx));
  }

  // Executive Summary of Recommendations (new page)
  doc.addPage();
  y = 20;
  
  doc.setFillColor(...purple);
  doc.rect(0, 0, pageWidth, 25, 'F');
  doc.setTextColor(255, 255, 255);
  doc.setFontSize(16);
  doc.setFont('helvetica', 'bold');
  doc.text('Recommended Next Steps', margin, 16);
  y = 40;

  doc.setTextColor(...dark);
  doc.setFontSize(10);
  doc.setFont('helvetica', 'normal');
  
  const nextSteps = [
    '1. Address High Priority findings first - these represent the most significant gaps in your security posture.',
    '2. Schedule a guided review session with Gray Corp to discuss findings and create a prioritized remediation roadmap.',
    '3. Evaluate the recommended free/open-source solutions for quick wins with minimal budget impact.',
    '4. Develop a business case for commercial solutions where open-source alternatives are insufficient.',
    '5. Reassess quarterly to track maturity progression and identify emerging gaps.',
    '6. Consider CIS Controls Implementation Group alignment based on your organizational risk profile.'
  ];

  nextSteps.forEach((step, idx) => {
    checkPageBreak(15);
    const lines = doc.splitTextToSize(step, pageWidth - 2 * margin - 5);
    lines.forEach(line => {
      doc.text(line, margin, y);
      y += 5;
    });
    y += 3;
  });

  y += 10;
  
  // CIS Controls Reference
  checkPageBreak(50);
  doc.setFontSize(11);
  doc.setFont('helvetica', 'bold');
  doc.text('CIS Controls v8 Reference', margin, y);
  y += 8;
  
  // Get unique CIS controls from findings
  const usedControls = new Set();
  allFindings.forEach(f => f.cisControls.forEach(c => usedControls.add(c)));
  
  const cisRefData = Array.from(usedControls).sort((a, b) => a - b).map(c => [
    `CIS ${c}`,
    cisControls[c]?.name || '',
    cisControls[c]?.description || ''
  ]);

  if (cisRefData.length > 0) {
    autoTable(doc, {
      startY: y,
      head: [['Control', 'Name', 'Description']],
      body: cisRefData,
      theme: 'striped',
      headStyles: { fillColor: purple, fontSize: 8 },
      bodyStyles: { fontSize: 7 },
      columnStyles: {
        0: { cellWidth: 20 },
        1: { cellWidth: 45 },
        2: { cellWidth: pageWidth - 2 * margin - 65 }
      },
      margin: { left: margin, right: margin }
    });
    y = doc.lastAutoTable.finalY + 10;
  }

  // Contact information
  checkPageBreak(40);
  doc.setFillColor(248, 246, 255);
  doc.roundedRect(margin, y, pageWidth - 2 * margin, 30, 3, 3, 'F');
  doc.setTextColor(...purple);
  doc.setFontSize(10);
  doc.setFont('helvetica', 'bold');
  doc.text('Ready to improve your SOC maturity?', margin + 5, y + 10);
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(9);
  doc.setTextColor(...gray);
  doc.text('Contact Gray Corp for a guided review session to discuss these findings and develop', margin + 5, y + 18);
  doc.text('a customized remediation roadmap aligned with your business objectives.', margin + 5, y + 24);

  // Footer on each page
  const pageCount = doc.internal.getNumberOfPages();
  for (let i = 1; i <= pageCount; i++) {
    doc.setPage(i);
    doc.setFontSize(8);
    doc.setTextColor(...gray);
    doc.text(`Gray Corp SOC Assessment • ${clientInfo.organization || 'Confidential'} • Page ${i} of ${pageCount}`, pageWidth / 2, 290, { align: 'center' });
  }

  // Save
  const filename = `SOC_Assessment_${(clientInfo.organization || 'Report').replace(/\s+/g, '_')}_${new Date().toISOString().split('T')[0]}.pdf`;
  doc.save(filename);
};

const styles = {
  container: { minHeight: '100vh', background: '#050508', fontFamily: "'Inter', -apple-system, sans-serif", color: '#e8e4f0' },
  header: { padding: '16px 24px', borderBottom: '1px solid rgba(139, 92, 246, 0.2)', display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: 'rgba(5,5,8,0.95)', position: 'sticky', top: 0, zIndex: 100 },
  logo: { display: 'flex', alignItems: 'center', gap: '12px' },
  logoIcon: { width: '36px', height: '36px', display: 'flex', alignItems: 'center', justifyContent: 'center' },
  logoText: { fontSize: '14px', fontWeight: '700', letterSpacing: '3px', background: 'linear-gradient(90deg, #c4b5fd, #86efac)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' },
  primaryBtn: { padding: '12px 24px', background: 'linear-gradient(135deg, #8b5cf6, #7c3aed)', border: 'none', borderRadius: '4px', color: 'white', fontSize: '13px', fontWeight: '600', cursor: 'pointer' },
  secondaryBtn: { padding: '10px 20px', background: 'transparent', border: '1px solid rgba(139, 92, 246, 0.3)', borderRadius: '4px', color: '#c4b5fd', fontSize: '12px', cursor: 'pointer' },
  tag: { padding: '4px 10px', background: 'rgba(139, 92, 246, 0.2)', borderRadius: '2px', fontSize: '10px', letterSpacing: '1px', color: '#c4b5fd' },
  input: { width: '100%', padding: '12px 14px', background: 'rgba(139, 92, 246, 0.05)', border: '1px solid rgba(139, 92, 246, 0.2)', borderRadius: '4px', color: '#e8e4f0', fontSize: '14px', outline: 'none' },
  select: { width: '100%', padding: '12px 14px', background: 'rgba(139, 92, 246, 0.05)', border: '1px solid rgba(139, 92, 246, 0.2)', borderRadius: '4px', color: '#e8e4f0', fontSize: '14px', outline: 'none' },
};

function App() {
  const [viewMode, setViewMode] = useState('intake');
  const [currentSection, setCurrentSection] = useState(0);
  const [currentSubsection, setCurrentSubsection] = useState(0);
  const [answers, setAnswers] = useState({});
  const [clientInfo, setClientInfo] = useState({ name: '', organization: '', email: '', industry: '', socSize: '', companySize: '' });
  const [user, setUser] = useState(null);
  const [pastAssessments, setPastAssessments] = useState([]);
  const [loadingAuth, setLoadingAuth] = useState(true);
  const [currentAssessmentId, setCurrentAssessmentId] = useState(null);
  const [saving, setSaving] = useState(false);
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [authMode, setAuthMode] = useState('signin'); // 'signin', 'signup', 'reset'
  const [authEmail, setAuthEmail] = useState('');
  const [authPassword, setAuthPassword] = useState('');
  const [authError, setAuthError] = useState('');
  const [authLoading, setAuthLoading] = useState(false);
  const [formErrors, setFormErrors] = useState({});
  const [processingPayment, setProcessingPayment] = useState(false);
  const [hasPaid, setHasPaid] = useState(false);

  // Check for payment success on page load
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const paymentStatus = urlParams.get('payment');
    const assessmentId = urlParams.get('assessment');
    
    if (paymentStatus === 'success' && assessmentId) {
      // Clear URL params
      window.history.replaceState({}, '', window.location.pathname);
      
      // Load the assessment and poll for hasPaid (webhook may take a moment)
      const loadPaidAssessment = async () => {
        let attempts = 0;
        const maxAttempts = 10;
        
        const poll = async () => {
          try {
            const docRef = doc(db, 'assessments', assessmentId);
            const docSnap = await getDoc(docRef);
            
            if (docSnap.exists()) {
              const data = docSnap.data();
              setAnswers(data.answers || {});
              setClientInfo(data.clientInfo || {});
              setCurrentAssessmentId(assessmentId);
              
              if (data.hasPaid) {
                setHasPaid(true);
                setViewMode('results');
              } else if (attempts < maxAttempts) {
                attempts++;
                setTimeout(poll, 1000); // Poll every second
              } else {
                // Assume payment succeeded even if webhook hasn't fired
                setHasPaid(true);
                setViewMode('results');
              }
            }
          } catch (error) {
            console.error('Error loading assessment:', error);
          }
        };
        
        poll();
      };
      
      loadPaidAssessment();
    }
  }, []);

  // Handle payment
  const handlePayment = async () => {
    if (!user || !currentAssessmentId) {
      alert('Please complete an assessment first');
      return;
    }

    setProcessingPayment(true);
    
    try {
      // Get Firebase auth token
      const token = await user.getIdToken();
      
      // Call the Cloud Function
      const response = await fetch('https://us-central1-graycorp-soc.cloudfunctions.net/createCheckoutSession', {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          assessmentId: currentAssessmentId,
        }),
      });

      const data = await response.json();
      
      if (data.error) {
        throw new Error(data.error);
      }

      // Redirect to Stripe Checkout
      window.location.href = data.url;
    } catch (error) {
      console.error('Payment error:', error);
      alert('Payment failed. Please try again.');
    } finally {
      setProcessingPayment(false);
    }
  };

  // Validate intake form
  const validateForm = () => {
    const errors = {};
    
    if (!clientInfo.name?.trim()) {
      errors.name = 'Name is required';
    }
    
    if (!clientInfo.organization?.trim()) {
      errors.organization = 'Organization is required';
    }
    
    if (!clientInfo.email?.trim()) {
      errors.email = 'Email is required';
    } else {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(clientInfo.email)) {
        errors.email = 'Please enter a valid email';
      }
    }
    
    if (!clientInfo.industry) {
      errors.industry = 'Industry is required';
    }
    
    if (!clientInfo.companySize) {
      errors.companySize = 'Company size is required';
    }
    
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  // Start assessment with validation
  const handleStartAssessment = () => {
    if (validateForm()) {
      setViewMode('assessment');
    }
  };

  // Auth state listener
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      setUser(currentUser);
      setLoadingAuth(false);
      if (currentUser) {
        // Pre-fill client info from Google profile
        setClientInfo(prev => ({
          ...prev,
          name: prev.name || currentUser.displayName || '',
          email: prev.email || currentUser.email || ''
        }));
        // Fetch past assessments
        const assessments = await fetchUserAssessments(currentUser.uid);
        setPastAssessments(assessments);
      } else {
        setPastAssessments([]);
      }
    });
    return () => unsubscribe();
  }, []);

  // Sign in with Google
  const handleGoogleSignIn = async () => {
    try {
      setAuthLoading(true);
      await signInWithPopup(auth, googleProvider);
      setShowAuthModal(false);
      resetAuthForm();
    } catch (error) {
      console.error('Sign in error:', error);
      setAuthError('Failed to sign in with Google');
    } finally {
      setAuthLoading(false);
    }
  };

  // Sign in with email/password
  const handleEmailSignIn = async (e) => {
    e.preventDefault();
    if (!authEmail || !authPassword) {
      setAuthError('Please fill in all fields');
      return;
    }
    try {
      setAuthLoading(true);
      setAuthError('');
      await signInWithEmailAndPassword(auth, authEmail, authPassword);
      setShowAuthModal(false);
      resetAuthForm();
    } catch (error) {
      console.error('Sign in error:', error);
      if (error.code === 'auth/user-not-found' || error.code === 'auth/wrong-password') {
        setAuthError('Invalid email or password');
      } else if (error.code === 'auth/invalid-email') {
        setAuthError('Invalid email address');
      } else {
        setAuthError('Failed to sign in');
      }
    } finally {
      setAuthLoading(false);
    }
  };

  // Sign up with email/password
  const handleEmailSignUp = async (e) => {
    e.preventDefault();
    if (!authEmail || !authPassword) {
      setAuthError('Please fill in all fields');
      return;
    }
    if (authPassword.length < 6) {
      setAuthError('Password must be at least 6 characters');
      return;
    }
    try {
      setAuthLoading(true);
      setAuthError('');
      await createUserWithEmailAndPassword(auth, authEmail, authPassword);
      setShowAuthModal(false);
      resetAuthForm();
    } catch (error) {
      console.error('Sign up error:', error);
      if (error.code === 'auth/email-already-in-use') {
        setAuthError('Email already in use');
      } else if (error.code === 'auth/invalid-email') {
        setAuthError('Invalid email address');
      } else if (error.code === 'auth/weak-password') {
        setAuthError('Password is too weak');
      } else {
        setAuthError('Failed to create account');
      }
    } finally {
      setAuthLoading(false);
    }
  };

  // Password reset
  const handlePasswordReset = async (e) => {
    e.preventDefault();
    if (!authEmail) {
      setAuthError('Please enter your email');
      return;
    }
    try {
      setAuthLoading(true);
      setAuthError('');
      await sendPasswordResetEmail(auth, authEmail);
      setAuthError('');
      setAuthMode('signin');
      alert('Password reset email sent! Check your inbox.');
    } catch (error) {
      console.error('Password reset error:', error);
      if (error.code === 'auth/user-not-found') {
        setAuthError('No account found with this email');
      } else {
        setAuthError('Failed to send reset email');
      }
    } finally {
      setAuthLoading(false);
    }
  };

  // Reset auth form
  const resetAuthForm = () => {
    setAuthEmail('');
    setAuthPassword('');
    setAuthError('');
    setAuthMode('signin');
  };

  // Sign out
  const handleSignOut = async () => {
    try {
      await signOut(auth);
      setViewMode('intake');
      setAnswers({});
      setClientInfo({ name: '', organization: '', email: '', industry: '', socSize: '', companySize: '' });
    } catch (error) {
      console.error('Sign out error:', error);
    }
  };

  // Delete account and all data
  const handleDeleteAccount = async () => {
    if (!user) return;
    
    const confirmed = window.confirm(
      'Are you sure you want to delete your account?\n\n' +
      'This will permanently delete:\n' +
      '• Your account\n' +
      '• All your assessments\n' +
      '• All your data\n\n' +
      'This action cannot be undone.'
    );
    
    if (!confirmed) return;
    
    try {
      // Delete all user's assessments
      const q = query(collection(db, 'assessments'), where('userId', '==', user.uid));
      const snapshot = await getDocs(q);
      const deletePromises = snapshot.docs.map(d => deleteDoc(doc(db, 'assessments', d.id)));
      await Promise.all(deletePromises);
      
      // Delete the user account
      await deleteUser(user);
      
      // Reset state
      setViewMode('intake');
      setAnswers({});
      setClientInfo({ name: '', organization: '', email: '', industry: '', socSize: '', companySize: '' });
      setPastAssessments([]);
      
      alert('Your account and all data have been deleted.');
    } catch (error) {
      console.error('Delete account error:', error);
      if (error.code === 'auth/requires-recent-login') {
        alert('For security, please sign out, sign back in, and try again.');
      } else {
        alert('Failed to delete account. Please try again.');
      }
    }
  };

  // Load a past assessment
  const loadAssessment = (assessment, resume = false) => {
    setAnswers(assessment.answers || {});
    setClientInfo(assessment.clientInfo || {});
    setCurrentAssessmentId(assessment.id);
    setHasPaid(assessment.hasPaid || false);
    if (resume || assessment.status === 'in-progress') {
      setViewMode('assessment');
    } else {
      setViewMode('results');
    }
  };

  // Save progress
  const handleSaveProgress = async () => {
    if (!user) {
      alert('Please sign in to save your progress');
      return;
    }
    setSaving(true);
    const sectionScores = {};
    assessmentSections.forEach(s => {
      sectionScores[s.id] = calculateSectionScore(s.id);
    });
    const overall = calculateOverallScore();
    const mat = getMaturityLevel(overall);
    const id = await saveAssessment(user.uid, clientInfo, answers, sectionScores, overall, mat.level, 'in-progress', currentAssessmentId);
    if (id) {
      setCurrentAssessmentId(id);
      const assessments = await fetchUserAssessments(user.uid);
      setPastAssessments(assessments);
    }
    setSaving(false);
  };

  // Start new assessment
  const startNewAssessment = () => {
    setAnswers({});
    setCurrentAssessmentId(null);
    setCurrentSection(0);
    setCurrentSubsection(0);
    setHasPaid(false);
    setViewMode('assessment');
  };

  // Delete assessment
  const handleDeleteAssessment = async (assessmentId) => {
    if (!window.confirm('Delete this assessment? This cannot be undone.')) return;
    try {
      await deleteDoc(doc(db, 'assessments', assessmentId));
      setPastAssessments(prev => prev.filter(a => a.id !== assessmentId));
    } catch (error) {
      console.error('Delete error:', error);
      alert('Failed to delete assessment');
    }
  };

  // Get all valid question IDs from current assessment
  const allQuestionIds = useMemo(() => {
    const ids = new Set();
    assessmentSections.forEach(s => s.subsections.forEach(sub => sub.questions.forEach(q => ids.add(q.id))));
    return ids;
  }, []);

  const { totalQuestions, answeredCount } = useMemo(() => {
    let total = 0;
    let answered = 0;
    assessmentSections.forEach(s => s.subsections.forEach(sub => { 
      sub.questions.forEach(q => {
        total++;
        if (answers[q.id] !== undefined) answered++;
      });
    }));
    return { totalQuestions: total, answeredCount: answered };
  }, [answers]);

  const progress = (answeredCount / totalQuestions) * 100;

  // Skip Logic: Gate questions that affect dependent questions
  // If gate question is Level 1-2 (index 0-1), dependents are forced to Level 1
  const gateQuestions = {
    // EDR: if no coverage, config questions don't matter
    'EDR-001': ['EDR-002', 'EDR-003', 'EDR-004', 'EDR-005', 'EDR-006', 'EDR-007'],
    // SIEM: if no central aggregation, SIEM questions are moot
    'AGG-001': ['AGG-002', 'AGG-003', 'AGG-004', 'AGG-005', 'AGG-006', 'RET-001', 'RET-002', 'RET-003'],
    // Cloud: if no cloud visibility, cloud security questions are moot
    'CLD-001': ['CLD-002', 'CLD-003', 'CLD-004', 'CLD-005'],
    // RBA: if no risk scoring, RBA detail questions are moot
    'RBA-001': ['RBA-002', 'RBA-003', 'RBA-004', 'RBA-005', 'RBA-006', 'RBA-007'],
    // SOAR: if no SOAR, SOAR questions are moot
    'SOAR-001': ['SOAR-002', 'SOAR-003', 'SOAR-004', 'SOAR-005'],
    // SOPs: if no SOPs, SOP quality questions are moot
    'SOP-001': ['SOP-002', 'SOP-003', 'SOP-004', 'SOP-005', 'SOP-006'],
    // NDR: if no NDR capability
    'NET-003': [],
    // ITDR: if no ITDR
    'IAM-004': [],
    // CTI: if no CTI program
    'CTI-001': ['CTI-002', 'CTI-003', 'CTI-004'],
    // Forensics: if no forensic capability
    'FOR-002': ['FOR-003', 'FOR-004'],
  };

  // Get effective score for a question (handles skip logic and N/A)
  const getEffectiveScore = (questionId) => {
    // N/A questions return null (excluded from scoring)
    if (answers[questionId] === 'na') return null;
    
    // Check if this question is gated by another
    for (const [gateId, dependents] of Object.entries(gateQuestions)) {
      if (dependents.includes(questionId)) {
        // Check if gate question is answered as Level 1 or 2 (index 0 or 1)
        const gateAnswer = answers[gateId];
        if (gateAnswer !== undefined && gateAnswer !== 'na' && gateAnswer <= 1) {
          return 1; // Force Level 1 score
        }
      }
    }
    // Return actual answer score, or 1 if unanswered
    if (answers[questionId] !== undefined && answers[questionId] !== 'na') {
      return answers[questionId] + 1; // Convert 0-4 index to 1-5 score
    }
    return 1; // Unanswered = Level 1
  };

  const calculateSectionScore = (sectionId) => {
    const section = assessmentSections.find(s => s.id === sectionId);
    if (!section) return 0;
    let total = 0, count = 0, hasAnswered = false;
    section.subsections.forEach(sub => sub.questions.forEach(q => {
      if (answers[q.id] !== undefined) hasAnswered = true;
      const score = getEffectiveScore(q.id);
      if (score !== null) { // Skip N/A questions
        total += score;
        count++;
      }
    }));
    // Return 0 if nothing answered yet (don't show 20% floor)
    if (!hasAnswered) return 0;
    return count === 0 ? 0 : (total / (count * 5)) * 100;
  };

  const calculateOverallScore = () => {
    let weightedTotal = 0, totalWeight = 0;
    assessmentSections.forEach(section => {
      const score = calculateSectionScore(section.id);
      weightedTotal += score * section.weight;
      totalWeight += section.weight;
    });
    return totalWeight === 0 ? 0 : weightedTotal / totalWeight;
  };

  const getSubsectionCompletion = (sectionId, subsectionId) => {
    const section = assessmentSections.find(s => s.id === sectionId);
    const subsection = section?.subsections.find(sub => sub.id === subsectionId);
    if (!subsection) return 0;
    const answered = subsection.questions.filter(q => answers[q.id] !== undefined).length;
    return (answered / subsection.questions.length) * 100;
  };

  const getSectionCompletion = (sectionId) => {
    const section = assessmentSections.find(s => s.id === sectionId);
    if (!section) return 0;
    let total = 0, answered = 0;
    section.subsections.forEach(sub => { total += sub.questions.length; answered += sub.questions.filter(q => answers[q.id] !== undefined).length; });
    return total === 0 ? 0 : (answered / total) * 100;
  };

  const Header = ({ showProgress = false }) => (
    <header style={styles.header}>
      <div style={styles.logo}>
        <div style={styles.logoIcon}>
          <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
            {/* Lilac flower cluster */}
            <circle cx="16" cy="8" r="3" fill="#a78bfa"/>
            <circle cx="12" cy="11" r="2.5" fill="#8b5cf6"/>
            <circle cx="20" cy="11" r="2.5" fill="#8b5cf6"/>
            <circle cx="10" cy="15" r="2.5" fill="#c4b5fd"/>
            <circle cx="16" cy="13" r="3" fill="#7c3aed"/>
            <circle cx="22" cy="15" r="2.5" fill="#c4b5fd"/>
            <circle cx="13" cy="18" r="2" fill="#a78bfa"/>
            <circle cx="19" cy="18" r="2" fill="#a78bfa"/>
            <circle cx="16" cy="20" r="2" fill="#8b5cf6"/>
            {/* Stem */}
            <path d="M16 22 L16 30" stroke="#6b7280" strokeWidth="2" strokeLinecap="round"/>
            {/* Leaves */}
            <ellipse cx="12" cy="26" rx="3" ry="1.5" fill="#6b7280" transform="rotate(-30 12 26)"/>
            <ellipse cx="20" cy="27" rx="3" ry="1.5" fill="#9ca3af" transform="rotate(30 20 27)"/>
          </svg>
        </div>
        <div><div style={styles.logoText}>GRAY CORP</div><div style={{ fontSize: '8px', color: '#6b7280', letterSpacing: '2px' }}>SOC ASSESSMENT</div></div>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
        {showProgress && (
          <>
            <span style={{ fontSize: '12px', color: '#8a8aaa' }}>{answeredCount}/{totalQuestions}</span>
            <div style={{ width: '150px', height: '4px', background: 'rgba(139, 92, 246, 0.2)', borderRadius: '2px', overflow: 'hidden' }}>
              <div style={{ width: `${progress}%`, height: '100%', background: 'linear-gradient(90deg, #8b5cf6, #86efac)' }} />
            </div>
            {progress >= 50 && <button onClick={() => setViewMode('results')} style={{ ...styles.primaryBtn, padding: '8px 16px', fontSize: '11px', background: 'linear-gradient(135deg, #22c55e, #86efac)', color: '#050508' }}>View Results</button>}
          </>
        )}
        {!loadingAuth && (
          user ? (
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              {user.photoURL ? (
                <img src={user.photoURL} alt="" style={{ width: '28px', height: '28px', borderRadius: '50%', border: '2px solid rgba(139, 92, 246, 0.3)' }} />
              ) : (
                <div style={{ width: '28px', height: '28px', borderRadius: '50%', background: 'linear-gradient(135deg, #8b5cf6, #7c3aed)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '12px', fontWeight: '600' }}>
                  {(user.email || '?')[0].toUpperCase()}
                </div>
              )}
              <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                <button onClick={handleSignOut} style={{ ...styles.secondaryBtn, padding: '6px 12px', fontSize: '11px' }}>Sign Out</button>
                <button onClick={handleDeleteAccount} style={{ background: 'none', border: 'none', color: '#6b7280', fontSize: '10px', cursor: 'pointer', padding: 0 }}>Delete Account</button>
              </div>
            </div>
          ) : (
            <button onClick={() => { resetAuthForm(); setShowAuthModal(true); }} style={{ ...styles.secondaryBtn, padding: '8px 14px', fontSize: '11px' }}>
              Sign In
            </button>
          )
        )}
      </div>
    </header>
  );

  // Auth Modal JSX (inline to prevent re-mount on state change)
  const authModalJSX = showAuthModal && (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.8)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }} onClick={() => setShowAuthModal(false)}>
      <div style={{ background: '#0a0a0f', border: '1px solid rgba(139, 92, 246, 0.3)', borderRadius: '12px', padding: '32px', width: '100%', maxWidth: '400px', margin: '20px' }} onClick={e => e.stopPropagation()}>
        <h2 style={{ fontSize: '20px', fontWeight: '500', marginBottom: '24px', textAlign: 'center' }}>
          {authMode === 'signin' && 'Sign In'}
          {authMode === 'signup' && 'Create Account'}
          {authMode === 'reset' && 'Reset Password'}
        </h2>
        
        {authError && (
          <div style={{ padding: '10px 14px', background: 'rgba(239, 68, 68, 0.1)', border: '1px solid rgba(239, 68, 68, 0.3)', borderRadius: '4px', marginBottom: '16px', fontSize: '13px', color: '#fca5a5' }}>
            {authError}
          </div>
        )}
        
        {authMode !== 'reset' && (
          <>
            <button 
              onClick={handleGoogleSignIn} 
              disabled={authLoading}
              style={{ width: '100%', padding: '12px', background: 'white', border: 'none', borderRadius: '4px', fontSize: '14px', fontWeight: '500', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px', color: '#333', marginBottom: '16px', opacity: authLoading ? 0.6 : 1 }}
            >
              <svg width="18" height="18" viewBox="0 0 24 24"><path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/><path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/><path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/><path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/></svg>
              Continue with Google
            </button>
            
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px' }}>
              <div style={{ flex: 1, height: '1px', background: 'rgba(139, 92, 246, 0.2)' }} />
              <span style={{ fontSize: '12px', color: '#8a8aaa' }}>or</span>
              <div style={{ flex: 1, height: '1px', background: 'rgba(139, 92, 246, 0.2)' }} />
            </div>
          </>
        )}
        
        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          <div>
            <label style={{ display: 'block', marginBottom: '6px', fontSize: '12px', color: '#c4b5fd' }}>Email</label>
            <input 
              type="email" 
              value={authEmail} 
              onChange={e => setAuthEmail(e.target.value)} 
              style={styles.input} 
              placeholder="you@example.com"
            />
          </div>
          
          {authMode !== 'reset' && (
            <div>
              <label style={{ display: 'block', marginBottom: '6px', fontSize: '12px', color: '#c4b5fd' }}>Password</label>
              <input 
                type="password" 
                value={authPassword} 
                onChange={e => setAuthPassword(e.target.value)} 
                style={styles.input} 
                placeholder="••••••••"
              />
            </div>
          )}
          
          <button 
            onClick={authMode === 'signin' ? handleEmailSignIn : authMode === 'signup' ? handleEmailSignUp : handlePasswordReset}
            disabled={authLoading}
            style={{ ...styles.primaryBtn, width: '100%', marginTop: '8px', opacity: authLoading ? 0.6 : 1 }}
          >
            {authLoading ? 'Please wait...' : authMode === 'signin' ? 'Sign In' : authMode === 'signup' ? 'Create Account' : 'Send Reset Link'}
          </button>
        </div>
        
        <div style={{ marginTop: '20px', textAlign: 'center', fontSize: '13px' }}>
          {authMode === 'signin' && (
            <>
              <button onClick={() => { setAuthError(''); setAuthMode('reset'); }} style={{ background: 'none', border: 'none', color: '#8b5cf6', cursor: 'pointer', fontSize: '13px' }}>Forgot password?</button>
              <div style={{ marginTop: '12px', color: '#8a8aaa' }}>
                Don't have an account?{' '}
                <button onClick={() => { setAuthError(''); setAuthMode('signup'); }} style={{ background: 'none', border: 'none', color: '#8b5cf6', cursor: 'pointer', fontSize: '13px' }}>Sign up</button>
              </div>
            </>
          )}
          {authMode === 'signup' && (
            <div style={{ color: '#8a8aaa' }}>
              Already have an account?{' '}
              <button onClick={() => { setAuthError(''); setAuthMode('signin'); }} style={{ background: 'none', border: 'none', color: '#8b5cf6', cursor: 'pointer', fontSize: '13px' }}>Sign in</button>
            </div>
          )}
          {authMode === 'reset' && (
            <button onClick={() => { setAuthError(''); setAuthMode('signin'); }} style={{ background: 'none', border: 'none', color: '#8b5cf6', cursor: 'pointer', fontSize: '13px' }}>← Back to sign in</button>
          )}
        </div>
      </div>
    </div>
  );

  if (viewMode === 'intake') {
    return (
      <div style={styles.container}>
        {authModalJSX}
        <Header />
        <main style={{ maxWidth: '600px', margin: '0 auto', padding: '48px 24px' }}>
          <div style={{ marginBottom: '32px' }}>
            <span style={styles.tag}>ENTERPRISE ASSESSMENT</span>
            <h1 style={{ fontSize: '28px', fontWeight: '300', margin: '16px 0 8px' }}>SOC Maturity Assessment</h1>
            <p style={{ color: '#8a8aaa', lineHeight: '1.6', fontSize: '14px' }}>Comprehensive evaluation across {totalQuestions} questions covering detection, operations, and incident response.</p>
          </div>
          <div style={{ background: 'rgba(139, 92, 246, 0.05)', border: '1px solid rgba(139, 92, 246, 0.2)', borderRadius: '8px', padding: '32px' }}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
                <div>
                  <label style={{ display: 'block', marginBottom: '6px', fontSize: '12px', color: formErrors.name ? '#ef4444' : '#c4b5fd' }}>Your Name *</label>
                  <input type="text" value={clientInfo.name} onChange={(e) => { setClientInfo(p => ({ ...p, name: e.target.value })); setFormErrors(p => ({ ...p, name: null })); }} style={{ ...styles.input, borderColor: formErrors.name ? 'rgba(239, 68, 68, 0.5)' : undefined }} placeholder="Jane Smith" />
                  {formErrors.name && <span style={{ fontSize: '11px', color: '#ef4444', marginTop: '4px', display: 'block' }}>{formErrors.name}</span>}
                </div>
                <div>
                  <label style={{ display: 'block', marginBottom: '6px', fontSize: '12px', color: formErrors.organization ? '#ef4444' : '#c4b5fd' }}>Organization *</label>
                  <input type="text" value={clientInfo.organization} onChange={(e) => { setClientInfo(p => ({ ...p, organization: e.target.value })); setFormErrors(p => ({ ...p, organization: null })); }} style={{ ...styles.input, borderColor: formErrors.organization ? 'rgba(239, 68, 68, 0.5)' : undefined }} placeholder="Acme Corp" />
                  {formErrors.organization && <span style={{ fontSize: '11px', color: '#ef4444', marginTop: '4px', display: 'block' }}>{formErrors.organization}</span>}
                </div>
              </div>
              <div>
                <label style={{ display: 'block', marginBottom: '6px', fontSize: '12px', color: formErrors.email ? '#ef4444' : '#c4b5fd' }}>Email *</label>
                <input type="email" value={clientInfo.email} onChange={(e) => { setClientInfo(p => ({ ...p, email: e.target.value })); setFormErrors(p => ({ ...p, email: null })); }} style={{ ...styles.input, borderColor: formErrors.email ? 'rgba(239, 68, 68, 0.5)' : undefined }} placeholder="jane@acme.com" />
                {formErrors.email && <span style={{ fontSize: '11px', color: '#ef4444', marginTop: '4px', display: 'block' }}>{formErrors.email}</span>}
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '20px' }}>
                <div>
                  <label style={{ display: 'block', marginBottom: '6px', fontSize: '12px', color: formErrors.industry ? '#ef4444' : '#c4b5fd' }}>Industry *</label>
                  <select value={clientInfo.industry} onChange={(e) => { setClientInfo(p => ({ ...p, industry: e.target.value })); setFormErrors(p => ({ ...p, industry: null })); }} style={{ ...styles.select, borderColor: formErrors.industry ? 'rgba(239, 68, 68, 0.5)' : undefined }}><option value="">Select...</option><option value="financial">Financial Services</option><option value="healthcare">Healthcare</option><option value="technology">Technology</option><option value="manufacturing">Manufacturing</option><option value="government">Government</option><option value="other">Other</option></select>
                  {formErrors.industry && <span style={{ fontSize: '11px', color: '#ef4444', marginTop: '4px', display: 'block' }}>{formErrors.industry}</span>}
                </div>
                <div>
                  <label style={{ display: 'block', marginBottom: '6px', fontSize: '12px', color: formErrors.companySize ? '#ef4444' : '#c4b5fd' }}>Company Size *</label>
                  <select value={clientInfo.companySize} onChange={(e) => { setClientInfo(p => ({ ...p, companySize: e.target.value })); setFormErrors(p => ({ ...p, companySize: null })); }} style={{ ...styles.select, borderColor: formErrors.companySize ? 'rgba(239, 68, 68, 0.5)' : undefined }}><option value="">Select...</option><option value="smb">1-500</option><option value="midmarket">500-5,000</option><option value="enterprise">5,000-25,000</option><option value="large">25,000+</option></select>
                  {formErrors.companySize && <span style={{ fontSize: '11px', color: '#ef4444', marginTop: '4px', display: 'block' }}>{formErrors.companySize}</span>}
                </div>
                <div>
                  <label style={{ display: 'block', marginBottom: '6px', fontSize: '12px', color: '#c4b5fd' }}>SOC Size</label>
                  <select value={clientInfo.socSize} onChange={(e) => setClientInfo(p => ({ ...p, socSize: e.target.value }))} style={styles.select}><option value="">Select...</option><option value="1-5">1-5</option><option value="6-15">6-15</option><option value="16-30">16-30</option><option value="30+">30+</option></select>
                </div>
              </div>
              {user ? (
                <button onClick={handleStartAssessment} style={{ ...styles.primaryBtn, marginTop: '12px', width: '100%' }}>Begin Assessment →</button>
              ) : (
                <div style={{ marginTop: '12px' }}>
                  <button onClick={() => { if (validateForm()) { resetAuthForm(); setAuthMode('signup'); setShowAuthModal(true); }}} style={{ ...styles.primaryBtn, width: '100%' }}>Create Account to Begin →</button>
                  <p style={{ textAlign: 'center', marginTop: '10px', fontSize: '12px', color: '#8a8aaa' }}>
                    Already have an account? <button onClick={() => { resetAuthForm(); setShowAuthModal(true); }} style={{ background: 'none', border: 'none', color: '#8b5cf6', cursor: 'pointer', fontSize: '12px' }}>Sign in</button>
                  </p>
                </div>
              )}
            </div>
          </div>

          {/* Past Assessments */}
          {user && pastAssessments.length > 0 && (
            <div style={{ marginTop: '32px' }}>
              <h3 style={{ fontSize: '14px', fontWeight: '500', marginBottom: '12px', color: '#c4b5fd' }}>📋 Your Assessments</h3>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                {pastAssessments.map((assessment) => {
                  const isInProgress = assessment.status === 'in-progress';
                  return (
                    <div 
                      key={assessment.id} 
                      style={{ padding: '14px 16px', background: 'rgba(139, 92, 246, 0.05)', border: `1px solid ${isInProgress ? 'rgba(234, 179, 8, 0.3)' : 'rgba(139, 92, 246, 0.15)'}`, borderRadius: '6px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
                    >
                      <div>
                        <div style={{ fontSize: '13px', fontWeight: '500', display: 'flex', alignItems: 'center', gap: '8px' }}>
                          {assessment.clientInfo?.organization || 'Assessment'}
                          {isInProgress && <span style={{ fontSize: '9px', padding: '2px 6px', background: 'rgba(234, 179, 8, 0.2)', color: '#eab308', borderRadius: '3px' }}>IN PROGRESS</span>}
                        </div>
                        <div style={{ fontSize: '11px', color: '#8a8aaa', marginTop: '2px' }}>
                          {assessment.updatedAt?.toDate ? assessment.updatedAt.toDate().toLocaleDateString() : 'Date unknown'}
                        </div>
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <div style={{ fontSize: '18px', fontWeight: '300', color: getMaturityLevel(assessment.overallScore || 0).color }}>
                          {Math.round(assessment.overallScore || 0)}
                        </div>
                        {isInProgress ? (
                          <button onClick={() => loadAssessment(assessment, true)} style={{ ...styles.secondaryBtn, padding: '6px 12px', fontSize: '11px', borderColor: 'rgba(234, 179, 8, 0.4)', color: '#eab308' }}>Resume →</button>
                        ) : (
                          <button onClick={() => loadAssessment(assessment)} style={{ ...styles.secondaryBtn, padding: '6px 12px', fontSize: '11px' }}>View</button>
                        )}
                        <button onClick={() => handleDeleteAssessment(assessment.id)} style={{ ...styles.secondaryBtn, padding: '6px 10px', fontSize: '11px', borderColor: 'rgba(239, 68, 68, 0.3)', color: '#ef4444' }} title="Delete">✕</button>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        </main>
      </div>
    );
  }

  if (viewMode === 'assessment') {
    const section = assessmentSections[currentSection];
    const subsection = section.subsections[currentSubsection];
    return (
      <div style={styles.container}>
        {authModalJSX}
        <Header showProgress />
        <div style={{ display: 'flex', minHeight: 'calc(100vh - 65px)' }}>
          <div style={{ width: '260px', borderRight: '1px solid rgba(139, 92, 246, 0.15)', background: 'rgba(10,10,18,0.5)', overflowY: 'auto' }}>
            {assessmentSections.map((s, sIdx) => {
              const comp = getSectionCompletion(s.id);
              const score = calculateSectionScore(s.id);
              const active = sIdx === currentSection;
              return (
                <div key={s.id}>
                  <div onClick={() => { setCurrentSection(sIdx); setCurrentSubsection(0); }} style={{ padding: '12px 16px', cursor: 'pointer', background: active ? 'rgba(139, 92, 246, 0.1)' : 'transparent', borderLeft: active ? '3px solid #8b5cf6' : '3px solid transparent' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>{Icons[s.icon] && React.createElement(Icons[s.icon], { style: { width: '16px', height: '16px' } })}<span style={{ fontSize: '12px', fontWeight: active ? '600' : '400', color: active ? '#e8e4f0' : '#8a8aaa' }}>{s.name}</span></div>
                      {comp === 100 && <span style={{ fontSize: '10px', color: getMaturityLevel(score).color, fontWeight: '600' }}>{Math.round(score)}</span>}
                    </div>
                    <div style={{ marginTop: '6px', marginLeft: '22px', height: '2px', background: 'rgba(139, 92, 246, 0.2)', borderRadius: '1px' }}><div style={{ width: `${comp}%`, height: '100%', background: comp === 100 ? '#86efac' : '#8b5cf6' }} /></div>
                  </div>
                  {active && <div style={{ paddingLeft: '24px', paddingBottom: '8px' }}>{s.subsections.map((sub, subIdx) => {
                    const subComp = getSubsectionCompletion(s.id, sub.id);
                    return <div key={sub.id} onClick={() => setCurrentSubsection(subIdx)} style={{ padding: '6px 12px', cursor: 'pointer', fontSize: '11px', color: subIdx === currentSubsection ? '#c4b5fd' : '#6a6a8a', background: subIdx === currentSubsection ? 'rgba(139, 92, 246, 0.1)' : 'transparent', borderRadius: '4px', marginBottom: '2px', display: 'flex', justifyContent: 'space-between' }}><span>{sub.name}</span>{subComp === 100 && <Icons.check style={{ width: '12px', height: '12px', color: '#86efac' }} />}</div>;
                  })}</div>}
                </div>
              );
            })}
          </div>
          <div style={{ flex: 1, padding: '32px 40px', overflowY: 'auto' }}>
            <div style={{ maxWidth: '700px' }}>
              <div style={{ display: 'flex', gap: '8px', marginBottom: '12px' }}><span style={styles.tag}>NIST: {section.nistFunction}</span><span style={{ ...styles.tag, background: 'rgba(134, 239, 172, 0.1)', color: '#86efac' }}>{section.name}</span></div>
              <h2 style={{ fontSize: '22px', fontWeight: '400', marginBottom: '6px' }}>{subsection.name}</h2>
              <p style={{ color: '#6a6a8a', marginBottom: '28px', fontSize: '13px' }}>{subsection.questions.length} questions</p>
              {subsection.questions.map((q) => (
                <div key={q.id} style={{ marginBottom: '24px', padding: '20px', background: answers[q.id] !== undefined ? 'rgba(139, 92, 246, 0.05)' : 'rgba(139, 92, 246, 0.02)', border: '1px solid rgba(139, 92, 246, 0.12)', borderRadius: '6px' }}>
                  <p style={{ fontSize: '14px', marginBottom: '14px', lineHeight: '1.5' }}><span style={{ color: '#8b5cf6', marginRight: '8px', fontSize: '11px' }}>{q.id}</span>{q.text}</p>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                    {q.options.map((opt, optIdx) => (
                      <label key={optIdx} onClick={() => setAnswers(p => ({ ...p, [q.id]: optIdx }))} style={{ display: 'flex', alignItems: 'flex-start', padding: '10px 12px', background: answers[q.id] === optIdx ? 'rgba(139, 92, 246, 0.15)' : 'transparent', border: answers[q.id] === optIdx ? '1px solid rgba(139, 92, 246, 0.4)' : '1px solid rgba(139, 92, 246, 0.08)', borderRadius: '4px', cursor: 'pointer' }}>
                        <div style={{ width: '16px', height: '16px', borderRadius: '50%', border: answers[q.id] === optIdx ? '2px solid #8b5cf6' : '2px solid rgba(139, 92, 246, 0.3)', marginRight: '10px', marginTop: '2px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>{answers[q.id] === optIdx && <div style={{ width: '8px', height: '8px', borderRadius: '50%', background: '#8b5cf6' }} />}</div>
                        <span style={{ fontSize: '13px', color: answers[q.id] === optIdx ? '#e8e4f0' : '#8a8aaa', flex: 1 }}>{opt}</span>
                        <span style={{ fontSize: '9px', color: '#4a4a6a', marginLeft: '8px' }}>L{optIdx + 1}</span>
                      </label>
                    ))}
                    {/* N/A Option */}
                    <label onClick={() => setAnswers(p => ({ ...p, [q.id]: 'na' }))} style={{ display: 'flex', alignItems: 'flex-start', padding: '10px 12px', background: answers[q.id] === 'na' ? 'rgba(107, 114, 128, 0.15)' : 'transparent', border: answers[q.id] === 'na' ? '1px solid rgba(107, 114, 128, 0.4)' : '1px solid rgba(107, 114, 128, 0.15)', borderRadius: '4px', cursor: 'pointer', marginTop: '4px' }}>
                      <div style={{ width: '16px', height: '16px', borderRadius: '50%', border: answers[q.id] === 'na' ? '2px solid #6b7280' : '2px solid rgba(107, 114, 128, 0.3)', marginRight: '10px', marginTop: '2px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>{answers[q.id] === 'na' && <div style={{ width: '8px', height: '8px', borderRadius: '50%', background: '#6b7280' }} />}</div>
                      <span style={{ fontSize: '13px', color: answers[q.id] === 'na' ? '#9ca3af' : '#6b7280', flex: 1 }}>Not Applicable</span>
                      <span style={{ fontSize: '9px', color: '#4a4a6a', marginLeft: '8px' }}>N/A</span>
                    </label>
                  </div>
                </div>
              ))}
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingTop: '20px', borderTop: '1px solid rgba(139, 92, 246, 0.15)' }}>
                <button onClick={() => { if (currentSubsection > 0) setCurrentSubsection(currentSubsection - 1); else if (currentSection > 0) { setCurrentSection(currentSection - 1); setCurrentSubsection(assessmentSections[currentSection - 1].subsections.length - 1); } }} disabled={currentSection === 0 && currentSubsection === 0} style={{ ...styles.secondaryBtn, opacity: (currentSection === 0 && currentSubsection === 0) ? 0.4 : 1, display: 'flex', alignItems: 'center', gap: '6px' }}><Icons.arrowLeft style={{ width: '14px', height: '14px' }} /> Previous</button>
                
                <div style={{ display: 'flex', gap: '10px' }}>
                  {user && (
                    <button onClick={handleSaveProgress} disabled={saving} style={{ ...styles.secondaryBtn, borderColor: 'rgba(134, 239, 172, 0.4)', color: '#86efac', opacity: saving ? 0.6 : 1, display: 'flex', alignItems: 'center', gap: '6px' }}>
                      <Icons.save style={{ width: '14px', height: '14px' }} /> {saving ? 'Saving...' : 'Save Progress'}
                    </button>
                  )}
                  
                  {currentSection === assessmentSections.length - 1 && currentSubsection === section.subsections.length - 1 ? (
                    <button onClick={async () => {
                      const sectionScores = {};
                      assessmentSections.forEach(s => {
                        sectionScores[s.id] = calculateSectionScore(s.id);
                      });
                      const overall = calculateOverallScore();
                      const mat = getMaturityLevel(overall);
                      const id = await saveAssessment(user?.uid, clientInfo, answers, sectionScores, overall, mat.level, 'completed', currentAssessmentId);
                      if (id) setCurrentAssessmentId(id);
                      if (user) {
                        const assessments = await fetchUserAssessments(user.uid);
                        setPastAssessments(assessments);
                      }
                      setViewMode('results');
                    }} style={{ ...styles.primaryBtn, background: 'linear-gradient(135deg, #22c55e, #86efac)', color: '#050508', display: 'flex', alignItems: 'center', gap: '6px' }}>Complete <Icons.checkCircle style={{ width: '14px', height: '14px' }} /></button>
                  ) : (
                    <button onClick={() => { if (currentSubsection < section.subsections.length - 1) setCurrentSubsection(currentSubsection + 1); else { setCurrentSection(currentSection + 1); setCurrentSubsection(0); } }} style={{ ...styles.primaryBtn, display: 'flex', alignItems: 'center', gap: '6px' }}>Next <Icons.arrowRight style={{ width: '14px', height: '14px' }} /></button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (viewMode === 'results') {
    const overallScore = calculateOverallScore();
    const maturity = getMaturityLevel(overallScore);
    
    const handleExportPDF = () => {
      generatePDF(clientInfo, answers, assessmentSections, calculateSectionScore, calculateOverallScore, getSectionCompletion);
    };
    
    return (
      <div style={styles.container}>
        {authModalJSX}
        <Header />
        <main style={{ maxWidth: '1000px', margin: '0 auto', padding: '40px 24px' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '32px' }}>
            <div>
              <span style={styles.tag}>RESULTS</span>
              <h1 style={{ fontSize: '28px', fontWeight: '300', margin: '12px 0 6px' }}>Assessment Complete</h1>
              <p style={{ color: '#8a8aaa', fontSize: '13px' }}>{clientInfo.organization || 'Organization'} • {answeredCount}/{totalQuestions} questions</p>
            </div>
            {hasPaid ? (
              <button onClick={handleExportPDF} style={{ ...styles.primaryBtn, display: 'flex', alignItems: 'center', gap: '6px' }}>
                <Icons.download style={{ width: '14px', height: '14px' }} /> Export PDF
              </button>
            ) : (
              <button onClick={handlePayment} disabled={processingPayment} style={{ ...styles.primaryBtn, background: 'linear-gradient(135deg, #22c55e, #16a34a)', opacity: processingPayment ? 0.6 : 1, display: 'flex', alignItems: 'center', gap: '6px' }}>
                {processingPayment ? 'Processing...' : <><Icons.unlock style={{ width: '14px', height: '14px' }} /> Unlock Full Report — $149</>}
              </button>
            )}
          </div>
          <div style={{ padding: '36px', background: 'rgba(139, 92, 246, 0.08)', border: '1px solid rgba(139, 92, 246, 0.2)', borderRadius: '8px', display: 'flex', alignItems: 'center', gap: '40px', marginBottom: '32px' }}>
            <div style={{ position: 'relative', width: '140px', height: '140px' }}>
              <svg viewBox="0 0 100 100" style={{ transform: 'rotate(-90deg)' }}><circle cx="50" cy="50" r="42" fill="none" stroke="rgba(139, 92, 246, 0.15)" strokeWidth="6" /><circle cx="50" cy="50" r="42" fill="none" stroke={maturity.color} strokeWidth="6" strokeDasharray={`${overallScore * 2.64} 264`} strokeLinecap="round" /></svg>
              <div style={{ position: 'absolute', inset: 0, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}><span style={{ fontSize: '36px', fontWeight: '200' }}>{Math.round(overallScore)}</span><span style={{ fontSize: '11px', color: '#8a8aaa' }}>/ 100</span></div>
            </div>
            <div><div style={{ display: 'inline-block', padding: '6px 14px', background: `${maturity.color}15`, border: `1px solid ${maturity.color}40`, borderRadius: '4px', marginBottom: '10px' }}><span style={{ color: maturity.color, fontWeight: '600', fontSize: '13px' }}>{maturity.level} Maturity</span></div><p style={{ color: '#8a8aaa', fontSize: '14px' }}>{maturity.description}</p></div>
          </div>

          {/* Peer Benchmarking */}
          {clientInfo.industry && clientInfo.companySize && (hasPaid ? (() => {
            const benchmark = getBenchmarkComparison(overallScore, clientInfo.industry, clientInfo.companySize);
            return (
              <div style={{ padding: '20px', background: 'rgba(139, 92, 246, 0.05)', border: '1px solid rgba(139, 92, 246, 0.15)', borderRadius: '6px', marginBottom: '32px' }}>
                <h3 style={{ fontSize: '14px', fontWeight: '500', marginBottom: '12px', display: 'flex', alignItems: 'center', gap: '8px' }}>📊 Peer Benchmarking</h3>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '20px' }}>
                  <div style={{ textAlign: 'center' }}>
                    <div style={{ fontSize: '28px', fontWeight: '300', color: '#8b5cf6' }}>{benchmark.percentile}<span style={{ fontSize: '14px', color: '#8a8aaa' }}>th</span></div>
                    <div style={{ fontSize: '11px', color: '#8a8aaa' }}>Percentile</div>
                  </div>
                  <div style={{ textAlign: 'center' }}>
                    <div style={{ fontSize: '28px', fontWeight: '300', color: benchmark.diff >= 0 ? '#22c55e' : '#ef4444' }}>{benchmark.diff >= 0 ? '+' : ''}{benchmark.diff}</div>
                    <div style={{ fontSize: '11px', color: '#8a8aaa' }}>vs. Peer Avg ({benchmark.peerAverage})</div>
                  </div>
                  <div style={{ textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <div style={{ fontSize: '12px', color: '#c4b5fd' }}>You are <strong style={{ color: benchmark.diff >= 0 ? '#86efac' : '#fca5a5' }}>{benchmark.comparison}</strong> similar organizations</div>
                  </div>
                </div>
              </div>
            );
          })() : (
            <div style={{ padding: '20px', background: 'rgba(139, 92, 246, 0.03)', border: '1px solid rgba(139, 92, 246, 0.1)', borderRadius: '6px', marginBottom: '32px', position: 'relative', overflow: 'hidden' }}>
              <div style={{ filter: 'blur(4px)', opacity: 0.4 }}>
                <h3 style={{ fontSize: '14px', fontWeight: '500', marginBottom: '12px' }}>📊 Peer Benchmarking</h3>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '20px' }}>
                  <div style={{ textAlign: 'center' }}><div style={{ fontSize: '28px', fontWeight: '300' }}>??</div><div style={{ fontSize: '11px' }}>Percentile</div></div>
                  <div style={{ textAlign: 'center' }}><div style={{ fontSize: '28px', fontWeight: '300' }}>??</div><div style={{ fontSize: '11px' }}>vs. Peer Avg</div></div>
                  <div style={{ textAlign: 'center' }}><div style={{ fontSize: '12px' }}>Industry comparison</div></div>
                </div>
              </div>
              <div style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <span style={{ background: 'rgba(139, 92, 246, 0.15)', padding: '6px 12px', borderRadius: '4px', fontSize: '12px', color: '#c4b5fd' }}><Icons.lock style={{ width: '12px', height: '12px', marginRight: '4px' }} /> Unlock with Full Report</span>
              </div>
            </div>
          ))}

          <h2 style={{ fontSize: '16px', fontWeight: '500', marginBottom: '16px' }}>Domain Breakdown</h2>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '12px', marginBottom: '32px' }}>
            {assessmentSections.map(s => { const score = calculateSectionScore(s.id); const mat = getMaturityLevel(score); const comp = getSectionCompletion(s.id); return (
              <div key={s.id} style={{ padding: '16px', background: 'rgba(139, 92, 246, 0.03)', border: '1px solid rgba(139, 92, 246, 0.12)', borderRadius: '6px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}><div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>{Icons[s.icon] && React.createElement(Icons[s.icon], { style: { width: '16px', height: '16px' } })}<span style={{ fontSize: '13px', fontWeight: '500' }}>{s.name}</span></div><div style={{ fontSize: '20px', fontWeight: '300', color: mat.color }}>{comp > 0 ? Math.round(score) : '—'}</div></div>
                <div style={{ height: '4px', background: 'rgba(139, 92, 246, 0.15)', borderRadius: '2px' }}><div style={{ width: `${comp > 0 ? score : 0}%`, height: '100%', background: mat.color }} /></div>
              </div>
            ); })}
          </div>

          {/* CIS Controls Coverage */}
          {hasPaid ? (() => {
            // Calculate CIS coverage
            const cisCoverage = {};
            Object.keys(cisControls).forEach(cid => {
              cisCoverage[cid] = { total: 0, score: 0 };
            });
            
            assessmentSections.forEach(section => {
              section.subsections.forEach(sub => {
                sub.questions.forEach(q => {
                  const controls = q.cis || questionCISMapping[q.id] || [];
                  controls.forEach(cid => {
                    if (cisCoverage[cid]) {
                      cisCoverage[cid].total++;
                      const answerScore = answers[q.id] !== undefined ? (answers[q.id] + 1) : 1;
                      cisCoverage[cid].score += answerScore;
                    }
                  });
                });
              });
            });
            
            const relevantControls = Object.entries(cisCoverage)
              .filter(([_, data]) => data.total > 0)
              .map(([cid, data]) => ({
                id: cid,
                ...cisControls[cid],
                score: Math.round((data.score / (data.total * 5)) * 100),
                questions: data.total
              }))
              .sort((a, b) => a.score - b.score);
            
            return (
              <div style={{ marginBottom: '32px' }}>
                <h2 style={{ fontSize: '16px', fontWeight: '500', marginBottom: '16px' }}>CIS Controls v8 Coverage</h2>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '8px' }}>
                  {relevantControls.map(c => {
                    const mat = getMaturityLevel(c.score);
                    return (
                      <div key={c.id} style={{ padding: '12px', background: 'rgba(139, 92, 246, 0.03)', border: '1px solid rgba(139, 92, 246, 0.1)', borderRadius: '4px' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '6px' }}>
                          <span style={{ fontSize: '10px', color: '#8b5cf6', fontWeight: '600' }}>CIS {c.id}</span>
                          <span style={{ fontSize: '14px', fontWeight: '500', color: mat.color }}>{c.score}</span>
                        </div>
                        <div style={{ fontSize: '11px', fontWeight: '500', marginBottom: '4px', lineHeight: '1.3' }}>{c.name}</div>
                        <div style={{ height: '3px', background: 'rgba(139, 92, 246, 0.15)', borderRadius: '2px' }}>
                          <div style={{ width: `${c.score}%`, height: '100%', background: mat.color, borderRadius: '2px' }} />
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            );
          })() : (
            <div style={{ marginBottom: '32px', position: 'relative', overflow: 'hidden' }}>
              <h2 style={{ fontSize: '16px', fontWeight: '500', marginBottom: '16px' }}>CIS Controls v8 Coverage</h2>
              <div style={{ filter: 'blur(4px)', opacity: 0.4 }}>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '8px' }}>
                  {[1,2,3,4,5,6,7,8,10,11,13,14,16,17,18].slice(0,9).map(n => (
                    <div key={n} style={{ padding: '12px', background: 'rgba(139, 92, 246, 0.03)', border: '1px solid rgba(139, 92, 246, 0.1)', borderRadius: '4px' }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '6px' }}>
                        <span style={{ fontSize: '10px' }}>CIS {n}</span>
                        <span style={{ fontSize: '14px' }}>??</span>
                      </div>
                      <div style={{ fontSize: '11px', marginBottom: '4px' }}>Control Name</div>
                      <div style={{ height: '3px', background: 'rgba(139, 92, 246, 0.15)', borderRadius: '2px' }} />
                    </div>
                  ))}
                </div>
              </div>
              <div style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', paddingTop: '30px' }}>
                <span style={{ background: 'rgba(139, 92, 246, 0.15)', padding: '6px 12px', borderRadius: '4px', fontSize: '12px', color: '#c4b5fd' }}><Icons.lock style={{ width: '12px', height: '12px', marginRight: '4px' }} /> Unlock with Full Report</span>
              </div>
            </div>
          )}

          <div style={{ padding: '24px', background: 'linear-gradient(135deg, rgba(134, 239, 172, 0.08), rgba(139, 92, 246, 0.08))', border: '1px solid rgba(134, 239, 172, 0.2)', borderRadius: '6px' }}><h3 style={{ fontSize: '14px', marginBottom: '12px' }}><Icons.target style={{ width: '14px', height: '14px', marginRight: '6px' }} /> Next Steps</h3><div style={{ color: '#8a8aaa', fontSize: '13px', lineHeight: '1.8' }}><p>1. Schedule a guided review to discuss findings</p><p>2. Focus on lowest-scoring domains first</p><p>3. Reassess quarterly to track progress</p></div></div>
          <div style={{ display: 'flex', justifyContent: 'center', marginTop: '32px' }}>
            <button onClick={() => setViewMode('assessment')} style={styles.secondaryBtn}>← Back to Assessment</button>
          </div>
        </main>
      </div>
    );
  }
  return null;
}

export default App;
